/* ASSETS  */
import boutonLire from 'assets/img/bouton_lire.png';
import boutonLireHoover from 'assets/img/bouton_lire_hoover.png';
import boutonRegarder from 'assets/img/bouton_regarder.png';
import boutonRegarderHoover from 'assets/img/bouton_regarder_hoover.png';
import boutonCoeur from 'assets/img/bouton_coeur.png';
import boutonCoeurHoover from 'assets/img/bouton_coeur_hoover.png';
import homeIconBlack from 'assets/img/home-icon-black.png';

import blockBlancFakeChoiceSmall from 'assets/img/bloc_blanc_fakechoice_small.png';
import blockBlancFakeChoiceMedium from 'assets/img/bloc_blanc_fakechoice_medium.png';

/* FOREGROUND */
import backpack from 'assets/img/journey/senait/backpack.png';
import handImage from 'assets/img/journey/senait/hand.png';
import hugImage from 'assets/img/journey/senait/hug.png';
import epilogue_silhouette from 'assets/img/journey/senait/silhouette_2.png';
import main_chute from 'assets/img/journey/senait/main_chute.png';
import bateau_pneumatique from 'assets/img/journey/senait/parcours_1_senait_bateau_penumatique.png';
import illu_viol from 'assets/img/journey/senait/parcours_1_senait_viol.png';

/* BACKGROUND */
import baseBackgroundImg from 'assets/img/home-background-min.jpg';
import backgoundPurple from 'assets/img/backgound_purple.jpg';
import backgroundSequence1 from 'assets/img/journey/senait/1_WW6WR6-min.jpg';
import backgroundSequence2 from 'assets/img/journey/senait/2_HR912C_retouche-min.jpg';
import backgroundSequence3 from 'assets/img/journey/senait/3_P22F8N.jpg';
import backgroundSequence4 from 'assets/img/journey/senait/Senait_portrait-min.png';
import mountainBackground from 'assets/img/journey/senait/4_2C3FTG0-min.jpg';
import backgroundMarket from 'assets/img/journey/senait/5_B8M52J_ok-min.jpg';
import desertImage from 'assets/img/journey/senait/6_W7XH55-min.jpg';
import darkWindow from 'assets/img/journey/senait/11_2B2609R-min.jpg';
import girlsWalking from 'assets/img/journey/senait/7_1692344854-min.jpg';
import greenSkirt from 'assets/img/journey/senait/8_X5B8E-min.jpg';
import campSoudan from 'assets/img/journey/senait/9_M52BJ1-min.jpg';
import batimentRoute from 'assets/img/journey/senait/10_BGRY4F-min.jpg';
import beach from 'assets/img/journey/senait/12_86gI_q3g-min.jpeg';
// import medecinBateau from 'assets/img/journey/senait/13_ENN0F8-min.jpg';
import refugee from 'assets/img/journey/senait/14_2D38X5R-min.jpg';
import phoneBooth from 'assets/img/journey/senait/15_DbeBw0Vg-min.jpeg';
import parcMaximilien from 'assets/img/journey/senait/16_KoninklijkCircus_17_DSC09329_KristofVadino-min.jpg';
import porteEtLit from 'assets/img/journey/senait/17_PPEW4N-min.jpg';
import pousette from 'assets/img/journey/senait/18_180219caritas_AM258-min.jpg';
import handsBehindWindow from 'assets/img/journey/senait/19_E92112-min.jpg';
import cuisineLegume from 'assets/img/journey/senait/20_IMG_0113-min.jpg';
import paperWork from 'assets/img/journey/senait/21_0B2AuC-g-min.jpg';

/* MAPS */
import map1 from 'assets/img/journey/senait/erythree_carte_1-min.png';
import map2 from 'assets/img/journey/senait/erythree_carte_2-min.png';
import map3 from 'assets/img/journey/senait/erythree_carte_3-min.png';
import map4 from 'assets/img/journey/senait/erythree_carte_4-min.png';
import map5 from 'assets/img/journey/senait/erythree_carte_5-min.png';
import map6 from 'assets/img/journey/senait/erythree_carte_6-min.png';

import mapIncoherence1 from 'assets/img/journey/senait/ecran_1_je_decide_FR.png';
import mapIncoherence2 from 'assets/img/journey/senait/ecran_2_je_rejoins_FR.png';

/* sounds */
import soundIntro from 'assets/sounds/senait_fr/SENAIT_FR_INTRO.mp3';
import SENAIT_FR_SEQ01 from 'assets/sounds/senait_fr/SENAIT_FR_SEQ01.mp3';
import SENAIT_FR_SEQ02 from 'assets/sounds/senait_fr/SENAIT_FR_SEQ02.mp3';
import SENAIT_FR_SEQ03 from 'assets/sounds/senait_fr/SENAIT_FR_SEQ03.mp3';
import SENAIT_FR_SEQ04 from 'assets/sounds/senait_fr/SENAIT_FR_SEQ04.mp3';
import SENAIT_FR_SEQ05 from 'assets/sounds/senait_fr/SENAIT_FR_SEQ05.mp3';
import SENAIT_FR_SEQ06A from 'assets/sounds/senait_fr/SENAIT_FR_SEQ06A.mp3';
import SENAIT_FR_SEQ06B from 'assets/sounds/senait_fr/SENAIT_FR_SEQ06B.mp3';
import SENAIT_FR_SEQ07 from 'assets/sounds/senait_fr/SENAIT_FR_SEQ07.mp3';
import SENAIT_FR_SEQ08 from 'assets/sounds/senait_fr/SENAIT_FR_SEQ08.mp3';
import SENAIT_FR_SEQ09 from 'assets/sounds/senait_fr/SENAIT_FR_SEQ09.mp3';
import SENAIT_FR_SEQ10 from 'assets/sounds/senait_fr/SENAIT_FR_SEQ10.mp3';
import SENAIT_FR_SEQ11 from 'assets/sounds/senait_fr/SENAIT_FR_SEQ11.mp3';
import SENAIT_FR_SEQ12 from 'assets/sounds/senait_fr/SENAIT_FR_SEQ12.mp3';
import SENAIT_FR_SEQ13 from 'assets/sounds/senait_fr/SENAIT_FR_SEQ13.mp3';
import SENAIT_FR_SEQ14 from 'assets/sounds/senait_fr/SENAIT_FR_SEQ14.mp3';
import SENAIT_FR_SEQ15 from 'assets/sounds/senait_fr/SENAIT_FR_SEQ15.mp3';
import SENAIT_FR_SEQ16 from 'assets/sounds/senait_fr/SENAIT_FR_SEQ16.mp3';
import SENAIT_FR_SEQ17 from 'assets/sounds/senait_fr/SENAIT_FR_SEQ17.mp3';
import SENAIT_FR_SEQ18 from 'assets/sounds/senait_fr/SENAIT_FR_SEQ18.mp3';
import SENAIT_FR_SEQ19 from 'assets/sounds/senait_fr/SENAIT_FR_SEQ19.mp3';
import SENAIT_FR_SEQ20 from 'assets/sounds/senait_fr/SENAIT_FR_SEQ20.mp3';
import SENAIT_FR_SEQ21 from 'assets/sounds/senait_fr/SENAIT_FR_SEQ21.mp3';
import SENAIT_FR_SEQ22 from 'assets/sounds/senait_fr/SENAIT_FR_SEQ22.mp3';
import SENAIT_FR_SEQ23 from 'assets/sounds/senait_fr/SENAIT_FR_SEQ23.mp3';

import SENAIT_FR_EPILOGUE1 from 'assets/sounds/senait_fr/SENAIT_FR_EPILOG1.mp3';
import SENAIT_FR_EPILOGUE_MILITAIRE from 'assets/sounds/senait_fr/SENAIT_FR_EPILOG2.mp3';
import SENAIT_FR_EPILOGUE_3 from 'assets/sounds/senait_fr/SENAIT_FR_EPILOG3.mp3';
import SENAIT_FR_EPILOGUE_FINAL1 from 'assets/sounds/senait_fr/SENAIT_FR_EPILOGFIN1.mp3';
import SENAIT_FR_EPILOGUE_FINAL2 from 'assets/sounds/senait_fr/SENAIT_FR_EPILOGFIN2.mp3';

import { getYoutubeIframe } from "./utils";
// import blocNoir from 'assets/img/bloc_noir-min.png';
// import blocNoirHover from 'assets/img/block_noir_hoover-min.png';

import PhylactereAlone from 'assets/img/journey/senait/Phylactere_alone.png';
import PhylactereMaman from 'assets/img/journey/senait/phylactere_maman_FR.png';

const colors = {
  violet: '#5A36E4',
};

const choiceButtonStyle = { marginLeft: 'auto', marginRight: 'auto', marginTop: 20, padding: '30px!important', minHeight: 100, maxWidth: 250, color: 'white' };

const otherChoiceButtonStyle = {
  ...choiceButtonStyle,
  fontSize: '1.5rem!important',
  fontWeight: '700!important',
  color: 'black!important',
  backgroundImage: `url(${blockBlancFakeChoiceSmall})!important`,
  maxWidth: 200,
  '&:hover': { textDecoration: 'underline' },
};

const base_choice_style = {
  containerStyle: {
    backgroundColor: 'white',
    color: 'black',
  },
  fixedImageBackground: backgroundSequence4,
  fixedImageBackgroundStyle: {
    backgroundSize: '35% auto',
    backgroundPosition: '95% center',
  },

  homeIcon: homeIconBlack,
  homeHoverIcon: homeIconBlack,

  contentStyle: {
    width: '50%',
    maxWidth: '1150px',
    marginLeft: '10%',
  },
};

const epilogeAnimationTiming = 2500;
const epilogeSoundAdditionalDelay = 1500;
const base_epilogue = {
  type: 'epilogue',
  background: { src: backgoundPurple },
  foreground: {
    src: epilogue_silhouette,
    // style: { height: '80vh', position: 'relative', top: '20vh', left: '-10vw', opacity: 1, transition: 'transform linear', transform: 'scale(1)', transformOrigin: '27.5% 65.1%' },
    style: {
      height: '80vh',
      position: 'relative',
      top: '20vh',
      left: '-10vw',
      opacity: 0,
      animationFillMode: 'forwards',
      animationTimingFunction: 'linear',
      transform: 'scale(.8)',
      transformOrigin: '27.5% 65.1%',
    },

    animations: [
      // { delay: 50, style: { transitionDuration: '2450ms', transform: 'scale(.8) translateY(-5vh) translateX(15vh)' } },
      // transitionDuration: '5000ms', transform: 'scale(.8)'
      { delay: 250, style: { animationName: 'opacityNoneToFull', animationDuration: `${epilogeAnimationTiming}ms` } },
    ],
  },
};

export const senait_fr = {
  description: {
    name: 'Senait',
    age: '13',
    city: 'Quala',
    country: 'Érythrée',
    text: 'Mon prénom signifie “bonne chance” et je trouve que ça me correspond bien. Je suis de nature positive, comme ma mère. J’ai aussi un caractère affirmé, comme mon père. En Érythrée, ça peut te créer des problèmes, donc ma mère dit que cette “chance” me sera nécessaire dans la vie.',
    sound: soundIntro,
  },
  additionalLoad: [
    { type: 'img', src: PhylactereAlone },
    { type: 'img', src: PhylactereMaman },
    { type: 'img', src: backgoundPurple },
    { type: 'img', src: backpack },
    { type: 'img', src: handImage },
    { type: 'img', src: hugImage },
    { type: 'img', src: epilogue_silhouette },
    { type: 'img', src: main_chute },
    { type: 'img', src: bateau_pneumatique },
    { type: 'img', src: illu_viol },
    { type: 'img', src: blockBlancFakeChoiceSmall },
    { type: 'img', src: blockBlancFakeChoiceMedium },
  ],
  steps: [
    {
      id: 'SENAIT 01',
      type: 'sequence',
      sound: SENAIT_FR_SEQ01,
      sound_delay: 50,
      sequence: [
        { type: 'text', text: 'Ma m\u00e8re tient un magasin, et je l\u2019aide apr\u00e8s l\u2019\u00e9cole. ', delay: 2100 },
        { type: 'text', text: 'C\u2019est dur, mais on se serre les coudes.', delay: 3010 },
        { type: 'text', text: 'C\u2019\u00e9tait plus facile quand mon p\u00e8re \u00e9tait l\u00e0, \nmais il a \u00e9t\u00e9 arr\u00eat\u00e9 il y a quelques ann\u00e9es. ', delay: 2080 },
        { type: 'text', text: 'Il \u00e9tait professeur, et il a \u00e9t\u00e9 d\u00e9nonc\u00e9 pour avoir critiqu\u00e9 \nla politique du gouvernement avec ses \u00e9l\u00e8ves.', delay: 3940 },
        { type: 'text', text: 'La police a alors d\u00e9couvert sa correspondance \navec des amis activistes en exil, et ils l\u2019ont arr\u00eat\u00e9.', delay: 5030 },
        { type: 'text', text: '', delay: 5840 },
        { type: 'goToNext', delay: 1130 },
      ],
      nextStepId: 'SENAIT 02',
      background: {
        src: backgroundSequence1,
        style: { animationFillMode: 'forwards', animationTimingFunction: 'linear' },
        animations: [{ delay: 50, style: { animationName: 'scale20', animationDuration: '23080ms' } }],
      },
      textBackgroundColor: '#af8d69',
    },
    {
      id: 'SENAIT 02',
      type: 'sequence',
      sound: SENAIT_FR_SEQ02,
      sound_delay: 50,
      sequence: [
        { type: 'text', text: 'Il y a une semaine, la police nous a convoqu\u00e9es ma m\u00e8re et moi \nparce que nous avons re\u00e7u la visite de mon oncle. ', delay: 3140 },
        { type: 'text', text: 'Un voisin l\u2019en a inform\u00e9.', delay: 4990 },
        { type: 'text', text: 'Mon oncle a fui l\u2019Érythr\u00e9e apr\u00e8s l\u2019arrestation de mon p\u00e8re \net milite pour sa lib\u00e9ration. ', delay: 1980 },
        { type: 'text', text: 'La police nous accuse de collaborer avec ces \u201ctraitres\u201d. ', delay: 4050 },
        { type: 'text', text: 'J\u2019ai \u00e9t\u00e9 renvoy\u00e9e chez moi \u00e0 la condition \nde d\u00e9noncer mon oncle la prochaine fois qu\u2019il vient. ', delay: 3010 },
        { type: 'text', text: 'Ma m\u00e8re est toujours l\u00e0-bas.  ', delay: 4850 },
        { type: 'text', text: '', delay: 1980 },
        { type: 'goToNext', delay: 4020 },
      ],
      nextStepId: 'SENAIT 03',
      background: {
        src: backgroundSequence2,
        style: { animationFillMode: 'forwards', animationTimingFunction: 'linear' },
        animations: [{ delay: 50, style: { animationName: 'scale20', animationDuration: '24000ms' } }],
      },
      textBackgroundColor: 'rgb(53, 43, 32)',
    },
    {
      id: 'SENAIT 03',
      type: 'sequence',
      sound: SENAIT_FR_SEQ03,
      sound_delay: 50,
      sequence: [
        { type: 'text', text: 'Que faire maintenant&thinsp;?', delay: 1020 },
        { type: 'text', text: 'Je ne peux pas pr\u00e9venir mon oncle car les t\u00e9l\u00e9phones sont sur \u00e9coute.', delay: 1200 },
        { type: 'text', text: 'Des policiers circulent et me surveillent. ', delay: 3800 },
        { type: 'text', text: 'J\u2019ai peur, je ne sais pas quoi faire.', delay: 2080 },
        { type: 'text', text: 'Ma voisine Mehret pr\u00e9voit de fuir l\u2019Érythr\u00e9e avec deux amies. ', delay: 2120 },
        { type: 'text', text: 'L\u2019id\u00e9e de les accompagner me traverse l\u2019esprit, mais je me ressaisis.', delay: 3860 },
        { type: 'text', text: 'C\u2019est interdit, les gardes-fronti\u00e8res peuvent m\u00eame te tirer dessus, ', delay: 3080 },
        { type: 'text', text: 'et une fois que tu quittes l\u2019Érythr\u00e9e tu ne peux plus revenir.', delay: 2060 },
        { type: 'text', text: 'M\u00eame si \u00e7a me permettrait de pr\u00e9venir mon oncle une fois pass\u00e9e la fronti\u00e8re. ', delay: 3010 },
        { type: 'text', text: 'Ce serait plus s\u00fbr que je quitte simplement la r\u00e9gion. ', delay: 3950 },
        { type: 'text', text: 'J\u2019ai une tante qui habite dans le nord de l\u2019Érythr\u00e9e, \nmais c\u2019est loin et j\u2019ai peur que \u00e7a paraisse suspect. ', delay: 2870 },
        { type: 'text', text: '', delay: 5950 },
        { type: 'goToNext', delay: 2020 },
      ],
      nextStepId: 'info1',
      background: {
        src: backgroundSequence3,
        style: { animationFillMode: 'forwards', animationTimingFunction: 'linear' },
        animations: [{ delay: 50, style: { animationName: 'scaleDown20', animationDuration: '35000ms' } }],
      },
    },
    {
      ...base_choice_style,
      id: 'info1',
      type: 'info',

      contentText:
        'Que ferais-tu si tu étais à ma place&thinsp;?<br/><span class="background-underlined large">Attendrais-tu&nbsp;de&nbsp;voir</span> ce qu’il se passe, quitterais-tu le <span class="background-underlined very-large">pays&nbsp;avec&nbsp;Mehret</span>, ou <span class="background-underlined large">partirais-tu&nbsp;seule</span> vers le nord de l’Érythrée&thinsp;?',
      actionText: 'Je m’informe pour aider Senait à prendre la bonne décision :',
      actions: [
        {
          type: 'button',
          key: 'button-watch-1',
          text: 'Je regarde l’interview de Dawit, expert de vécu en Érythrée',
          buttonStyle: { '&:hover': { color: colors.violet } },
          icon: boutonRegarder,
          iconHover: boutonRegarderHoover,
          action: 'openDialog',
          dialogContent: {
            transition: 'slideUp',
            type: 'video',
            videoIframe: getYoutubeIframe('V3a2QB8XdBA'),
          },
        },
        {
          type: 'button',
          key: 'button-watch-2',
          text: 'J’écoute le témoignage de fuite de Sham',
          buttonStyle: { '&:hover': { color: colors.violet } },
          icon: boutonRegarder,
          iconHover: boutonRegarderHoover,
          action: 'openDialog',
          dialogContent: {
            transition: 'slideUp',
            type: 'video',
            videoIframe: getYoutubeIframe('r9kQFPpCXzc'),
          },
        },
        {
          type: 'button',
          key: 'button-read',
          text: 'Je lis le rapport d’Amnesty sur l’Érythrée',
          buttonStyle: { '&:hover': { color: colors.violet } },
          icon: boutonLire,
          iconHover: boutonLireHoover,
          action: 'openDialog',
          dialogContent: {
            transition: 'slideUp',
            backgroundImage: backgoundPurple,
            type: 'text',
            title: "Rapport d'Amnesty sur l'Érythrée<br/><span class='subtitle'>(résumé du rapport de 2020)</span>",
            text: "<span class='inline-title'>Détentions arbitraires et disparitions forcées</span>Des centaines de personnes critiques à l’égard du gouvernement étaient toujours en détention arbitraire, sans inculpation ni jugement, et sans pouvoir entrer en contact avec leur famille ni leurs avocats.<span class='inline-title'>Liberté d’expression</span>En 2020, l’Érythrée était le pays le plus censuré au monde et celui qui comptait le plus grand nombre de journalistes emprisonnés selon le Comité pour la protection des journalistes.<span class='inline-title'>Travail forcé</span>Le service national obligatoire de durée indéterminée est toujours en place. Des milliers de personnes demeuraient enrôlées sans limitation de durée, souvent pendant plusieurs dizaines d’années. Le gouvernement utilisait les appelé·e·s pour travailler sur des projets d’infrastructure (routes, agriculture…).<span class='inline-title'>Personnes réfugiées </span>Des milliers d’Érythréen·ne·s continuent de fuir le pays. Ils ont continué de subir de graves atteintes à leurs droits humains en route, notamment en Libye, où beaucoup sont victimes de détention, enlèvement, violences sexuelles, torture, et d’autres formes de mauvais traitements.<br/><br/>Ceci est un résumé du <a href='https://www.amnesty.org/fr/countries/africa/eritrea/report-eritrea/' target='_blank'>rapport d’Amnesty de 2020 sur l’Érythrée</a>.",
          },
        },
      ],
      nextButtonStyle: {
        '&:hover': { color: colors.violet },
      },
      nextButtonText: 'Prendre une décision >',
      nextStepId: 'choice1',
    },
    {
      id: 'choice1',
      type: 'choice',

      ...base_choice_style,
      contentText:
        'Que ferais-tu si tu étais à ma place&thinsp;?<br/><span class="background-underlined large">Attendrais-tu&nbsp;de&nbsp;voir</span> ce qu’il se passe, quitterais-tu le <span class="background-underlined very-large">pays&nbsp;avec&nbsp;Mehret</span>, ou <span class="background-underlined large">partirais-tu&nbsp;seule</span> vers le nord de l’Érythrée&thinsp;?',
      choices: [
        {
          type: 'button',
          key: 'button-1',
          text: "Se réfugier dans le nord de l'Érythrée",
          buttonStyle: choiceButtonStyle,
          action: 'showConfirmation',
          confirmationContent: {
            title: '<span class="background-underlined large">Es-tu certain&middot;e&thinsp;?</span><br/>C’est un long voyage à faire seule à mon âge.',
            buttons: [
              {
                text: 'Oui, je suis<br/>sûr&middot;e de moi',
                buttonStyle: choiceButtonStyle,
                action: 'goNext',
                nextStepId: 'SENAIT 09',
              },
              {
                text: 'Je reviens<br/>sur ma décision',
                buttonStyle: choiceButtonStyle,
                action: 'closeConfirmation',
              },
            ],
          },
        },
        {
          type: 'button',
          key: 'button-2',
          text: "Fuir l'Érythrée avec Mehret",
          buttonStyle: choiceButtonStyle,
          action: 'showConfirmation',
          confirmationContent: {
            title:
              '<span class="background-underlined large">Es-tu certain&middot;e&thinsp;?</span><br/>Si je quitte l’Érythrée, je ne pourrais peut-être plus <span class="background-underlined large">jamais revenir</span>.',
            buttons: [
              {
                text: 'Oui, je suis<br/>sûr&middot;e de moi',
                buttonStyle: choiceButtonStyle,
                action: 'goNext',
                nextStepId: 'SENAIT 04',
              },
              {
                text: 'Je reviens<br/>sur ma décision',
                buttonStyle: choiceButtonStyle,
                action: 'closeConfirmation',
              },
            ],
          },
        },
        {
          type: 'button',
          key: 'button-3',
          text: 'Attendre',
          buttonStyle: choiceButtonStyle,
          action: 'showConfirmation',
          confirmationContent: {
            title: '<span class="background-underlined large">Es-tu certain&middot;e&thinsp;?</span><br/>Comment pourrais-je imaginer dénoncer mon oncle s’il revient&thinsp;?',
            buttons: [
              {
                text: 'Oui, je suis<br/>sûr&middot;e de moi',
                buttonStyle: choiceButtonStyle,
                action: 'goNext',
                nextStepId: 'SENAIT 09',
              },
              {
                text: 'Je reviens<br/>sur ma décision',
                buttonStyle: choiceButtonStyle,
                action: 'closeConfirmation',
              },
            ],
          },
        },
      ],
    },
    //5
    {
      id: 'SENAIT 04',
      type: 'sequence',
      sound: SENAIT_FR_SEQ04,
      sound_delay: 50,
      sequence: [
        { type: 'text', text: 'Mehret a d\u2019abord refus\u00e9 que je les accompagne, \nparce que je suis trop jeune.', delay: 1050 },
        { type: 'text', text: 'Mais j\u2019ai insist\u00e9 et elle a fini par c\u00e9der. ', delay: 2980 },
        { type: 'text', text: 'Maintenant, il reste \u00e0 pr\u00e9parer le d\u00e9part, en secret. ', delay: 2110 },
        { type: 'text', text: 'Si nos familles l\u2019apprenaient, elles nous emp\u00eacheraient de partir ', delay: 4040 },
        { type: 'text', text: '\u00e0 cause du risque d\u2019\u00eatre tu\u00e9 par les gardes-fronti\u00e8res. ', delay: 2000 },
        { type: 'text', text: 'On devra traverser dans la montagne pendant deux jours, \nen marchant la nuit et en se cachant le jour. ', delay: 3010 },
        { type: 'text', text: '', delay: 6810 },
        { type: 'goToNext', delay: 3230 },
      ],
      background: {
        src: baseBackgroundImg,
        // style: { },
        // animations: [
        //   { delay: 1000, style: { transitionDuration: '2000ms', left: '0%' } },
        //   { delay: 2000, style: { transitionDuration: '2000ms', height: '120%', top: '-10%', width: '140%', left: '-40%' } },
        // ],
      },
      foreground: {
        src: backpack,
        style: { height: '68%', position: 'relative', top: '-5%', opacity: 0 }, // transition: 'transform linear, opacity linear'
        animations: [
          { delay: 4040, style: { animationName: 'opacityNoneToFull, scale100To74', animationDuration: '11020ms' } }, //, transitionDuration: '11020ms', transform: 'scale(0.74)', opacity: 1
          { delay: 11020, style: { animationName: 'opacityFullToNone, scale74To50', animationDuration: '10170ms' } }, //, transitionDuration: '10170ms', transform: 'scale(0.50)', opacity: 0
        ],
      },

      nextStepId: 'SENAIT 05',
    },
    {
      id: 'SENAIT 05',
      type: 'sequence',
      sound: SENAIT_FR_SEQ05,
      sound_delay: 50,
      sequence: [
        { type: 'text', text: 'Nous avons d\u00e9marr\u00e9 \u00e0 la tomb\u00e9e de la nuit, ', delay: 1180 },
        { type: 'text', text: 'depuis le lieu de rendez-vous indiqu\u00e9 par notre passeur. ', delay: 1930 },
        { type: 'text', text: 'À présent, il fait nuit noire. ', delay: 3030 },
        { type: 'text', text: 'On ne voit presque plus o\u00f9 on marche. ', delay: 2060 },
        { type: 'text', text: 'Je me tords la cheville en glissant sur une pierre. ', delay: 1960 },
        { type: 'text', text: 'Je n\u2019arrive plus \u00e0 marcher. ', delay: 1990 },
        { type: 'text', text: 'Mehret fait un n\u0153ud dans son ch\u00e2le pour me porter sur son dos, ', delay: 1950 },
        { type: 'text', text: 'mais le passeur le lui arrache.', delay: 2120 },
        { type: 'text', text: 'Il dit que c\u2019est perdu pour moi, \net qu\u2019elle va se faire arr\u00eater aussi. ', delay: 1890 },
        { type: 'text', text: 'Mehret le menace \u00e0 son tour de le d\u00e9noncer si elle est arr\u00eat\u00e9e. ', delay: 3030 },
        { type: 'text', text: 'Il la gifle et la tire avec lui, ', delay: 3030 },
        { type: 'text', text: 'et me dit de retourner au lieu de rendez-vous.', delay: 1990 },
        { type: 'text', text: 'Je suis terroris\u00e9e \u00e0 l\u2019id\u00e9e qu\u2019ils m\u2019abandonnent \net que les gardes-fronti\u00e8res me trouvent,', delay: 2020 },
        { type: 'text', text: 'mais je ne veux pas mettre tout le monde en danger. ', delay: 3970 },
        { type: 'text', text: '', delay: 2850 },
        { type: 'goToNext', delay: 2230 },
      ],
      background: {
        src: mountainBackground,
        style: { transformOrigin: 'center 80%' },
        // animations: [
        //   { delay: 50, style: { transitionDuration: '36010ms', transform: 'scale(1.5)' } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        // ],
        animations: [{ delay: 4040, style: { animationName: 'scale100To150', animationDuration: '36010ms' } }],
      },
      backgroundEffect: {
        style: { opacity: 0, backgroundColor: 'black' },
        animations: [
          { delay: 50, style: { animationName: 'opacityNoneTo60', animationDuration: '8030ms' } }, //transitionDuration: '8030ms', opacity: 0.6
          { delay: 8030, style: { animationName: 'opacity60ToFull', animationDuration: '28010ms' } }, //transitionDuration: '28010ms', opacity: 1
        ],
      },
      foreground: {
        src: handImage,
        style: { height: '70%', position: 'relative', top: '-6%', opacity: 0, transform: 'scale(0.75) translateX(-10vh)' }, //transform: 'scale(0.75) translateX(-10vh)',transition: 'transform linear, opacity linear, left linear', transformOrigin: 'center'
        animations: [
          { delay: 25020, style: { transform: 'scale(0.75) translateX(-10vh)', animationName: 'opacityNoneToFull', animationDuration: '0ms' } }, //transitionDuration: '0ms', transform: 'scale(0.75) translateX(-10vh)', opacity: 1
          { delay: 50, style: { opacity: 1, animationName: 'handAnimationPart1', animationDuration: '7100ms' } }, // transform: 'translateX(1vh)', opacity: 1
          { delay: 7100, style: { animationDuration: '3920ms', animationName: 'handAnimationPart2, opacityFullToNone' } }, //transform: ' translateX(10vh)', opacity: 0
        ],
      },

      nextStepId: 'info_GYUI',
    },
    {
      ...base_choice_style,
      id: 'info_GYUI',
      type: 'info',

      contentText: 'Que ferais-tu si tu étais à ma place&thinsp;?<br/><span class="background-underlined very-large">Obéirais-tu au passeur ?</span>',
      actionText: 'Je m’informe pour aider Senait à prendre la bonne décision :',
      actions: [
        {
          type: 'button',
          key: 'button-ask',
          text: 'Je demande a Senait ce que lui dit son cœur',
          buttonStyle: { '&:hover': { color: colors.violet } },
          icon: boutonCoeur,
          iconHover: boutonCoeurHoover,
          action: 'openDialog',
          dialogContent: {
            type: 'image',
            imageSrc: PhylactereAlone,
            imageStyle: { marginBottom: '15vh', width: '30vw', maxWidth: '400px', height: 'auto', maxHeight: '50vh', objectFit: 'contain', objectPosition: 'center' },
          },
        },
      ],
      nextButtonStyle: {
        '&:hover': { color: colors.violet },
      },
      nextButtonText: 'Prendre une décision >',
      nextStepId: 'choice2',
    },
    {
      id: 'choice2',
      type: 'choice',

      ...base_choice_style,
      contentText: 'Que ferais-tu si tu étais à ma place&thinsp;?<br/><span class="background-underlined very-large" >Obéirais-tu au passeur&thinsp;?</span>',

      choices: [
        {
          type: 'button',
          key: 'button-1',
          text: 'Supplier Mehret de ne pas me laisser',
          buttonStyle: choiceButtonStyle,
          action: 'goNext',
          nextStepId: 'SENAIT 06A',
        },
        {
          type: 'button',
          key: 'button-2',
          text: 'Retourner au lieu de rendez-vous',
          buttonStyle: choiceButtonStyle,
          action: 'goNext',
          nextStepId: 'SENAIT 06B',
        },
      ],
    },
    {
      id: 'SENAIT 06A',
      type: 'sequence',
      sound: SENAIT_FR_SEQ06A,
      sound_delay: 50,
      sequence: [
        { type: 'text', text: 'Je supplie Mehret, et elle revient. ', delay: 3110 },
        { type: 'text', text: 'Le gar\u00e7on nous abandonne et continue avec les autres. ', delay: 2090 },
        { type: 'text', text: 'D\u2019un coup, on entend des coups de feu au loin. ', delay: 2940 },
        { type: 'text', text: 'On se couche sur le sol. ', delay: 1990 },
        { type: 'text', text: 'Dans la distance, on distingue trois silhouettes \nqui traversent les champs et qui se font tirer dessus. ', delay: 1060 },
        { type: 'text', text: 'J\u2019en vois un tomber. ', delay: 4970 },
        { type: 'text', text: '\u00c7a aurait pu \u00eatre nous. ', delay: 1990 },
        { type: 'text', text: 'On est sous le choc. ', delay: 2020 },
        { type: 'text', text: 'On est seules \u00e0 pr\u00e9sent, au milieu de nulle part, \net on ne connait pas le chemin vers l\u2019\u00c9thiopie. ', delay: 1060 },
        { type: 'text', text: 'Je sursaute \u00e0 chaque bruit\u2026', delay: 4800 },
        { type: 'text', text: '', delay: 1970 },
        { type: 'goToNext', delay: 5200 },
      ],
      background: { src: baseBackgroundImg },
      foreground: {
        src: hugImage,
        style: { height: '70%', position: 'relative', top: '-6%', opacity: 0, transformOrigin: 'center top' }, //transition: 'transform linear, opacity linear',

        animations: [
          // { delay: 2950, style: { animationDuration: '50ms', animationName:'opacityNoneToFull', } }, //transform: 'scale(1)', opacity: 0
          { delay: 3000, style: { animationDuration: '2000ms', animationName: ' opacityNoneToFull' } }, //scale20transform: 'scale(1.2)', ,opacity: 1
          { delay: 2000, style: { animationDuration: '3180ms', animationName: ' opacityFullToNone' } }, //scaleDown20, //,transform: 'scale(1)', opacity: 0
        ],
      },

      nextStepId: 'map1',
    },
    //10
    {
      id: 'SENAIT 06B',
      type: 'sequence',
      sound: SENAIT_FR_SEQ06B,
      sound_delay: 50,
      sequence: [
        { type: 'text', text: 'D\u2019un coup, on entend des coups de feu. ', delay: 3190 },
        { type: 'text', text: 'Je panique et je supplie Mehret de ne pas me laisser. ', delay: 2040 },
        { type: 'text', text: 'Elle revient. ', delay: 2960 },
        { type: 'text', text: 'Le gar\u00e7on nous abandonne et continue avec les autres. ', delay: 1040 },
        { type: 'text', text: 'On se couche sur le sol. ', delay: 2980 },
        { type: 'text', text: 'Dans la distance on distingue trois silhouettes \nqui traversent les champs et qui se font tirer dessus.', delay: 1900 },
        { type: 'text', text: 'J\u2019en vois un tomber. ', delay: 4900 },
        { type: 'text', text: '\u00c7a aurait pu \u00eatre nous. ', delay: 2010 },
        { type: 'text', text: 'On est sous le choc. ', delay: 2020 },
        { type: 'text', text: 'On est seules \u00e0 pr\u00e9sent, au milieu de nulle part, \net on ne connait pas le chemin vers l\u2019\u00c9thiopie. ', delay: 1070 },
        { type: 'text', text: 'Je sursaute \u00e0 chaque bruit\u2026', delay: 4040 },
        { type: 'text', text: '', delay: 1950 },
        { type: 'goToNext', delay: 4040 },
      ],
      background: { src: baseBackgroundImg },
      foreground: {
        src: hugImage,
        style: { height: '70%', position: 'relative', top: '-6%', opacity: 0, transformOrigin: 'center top' }, //transition: 'transform linear, opacity linear',
        animations: [
          // { delay: 8140, style: { transitionDuration: '50ms', transform: 'scale(1)', opacity: 0 } },
          { delay: 8190, style: { animationDuration: '2810ms', animationName: 'opacityNoneToFull' } }, //scale20//,transform: 'scale(1.2)', opacity: 1
          { delay: 2810, style: { animationDuration: '3000ms', opacity: 1, animationName: ' opacityFullToNone' } }, //scaleDown20 transform: 'scale(1)', opacity: 0
        ],
      },
      nextStepId: 'map1',
    },
    {
      id: 'map1',
      type: 'map',
      background: baseBackgroundImg,
      mapImage: map1,
      mapContainerClass: 'cursor-gray',
      nextStepDelay: 3500,
      nextStepId: 'SENAIT 07',
    },
    {
      id: 'SENAIT 07',
      type: 'sequence',
      sound: SENAIT_FR_SEQ07,
      sound_delay: 50,
      sequence: [
        { type: 'text', text: 'Nous avons retrouv\u00e9 les amies de Mehret, ', delay: 1030 },
        { type: 'text', text: 'et avons r\u00e9ussi \u00e0 rejoindre Khartoum, au Soudan. ', delay: 1974 },
        { type: 'text', text: 'De l\u00e0, j\u2019ai pu t\u00e9l\u00e9phoner \u00e0 mon oncle pour le pr\u00e9venir, ', delay: 3076 },
        { type: 'text', text: 'et j\u2019ai appris que ma m\u00e8re a \u00e9t\u00e9 lib\u00e9r\u00e9e.', delay: 2921 },
        { type: 'text', text: 'Je travaille comme domestique dans une famille. ', delay: 2129 },
        { type: 'text', text: 'Je ne peux plus aller \u00e0 l\u2019\u00e9cole, \nmais heureusement mes patrons me traitent bien, ', delay: 2070 },
        { type: 'text', text: 'm\u00eame si je ne suis pas bien pay\u00e9e. ', delay: 3860 },
        { type: 'text', text: 'Mehret n\u2019a pas cette chance&thinsp;: \nson patron la bat. ', delay: 2060 },
        { type: 'text', text: 'On ne peut pas porter plainte \u00e0 la police \nparce qu\u2019on n\u2019a pas de papiers. ', delay: 3110 },
        { type: 'text', text: 'On peut m\u00eame \u00eatre arr\u00eat\u00e9es dans la rue \net renvoy\u00e9es en \u00c9rythr\u00e9e. ', delay: 3810 },
        { type: 'text', text: 'On ne se sent pas en s\u00e9curit\u00e9. ', delay: 3150 },
        { type: 'text', text: 'Les filles pr\u00e9f\u00e8rent continuer jusqu\u2019en Libye, \net puis jusqu\u2019en Europe. ', delay: 2870 },
        { type: 'text', text: 'Je sais que c\u2019est un voyage dangereux mais\u2026', delay: 4040 },
        { type: 'text', text: 'je ne veux pas me retrouver seule \net sans leur protection ici. ', delay: 2100 },
        { type: 'text', text: '', delay: 3800 },
        { type: 'goToNext', delay: 4110 },
      ],
      background: {
        src: backgroundMarket,
        style: { animationFillMode: 'forwards', animationTimingFunction: 'linear' },
        animations: [
          // { delay: 50, style: { transitionDuration: '23080ms', transform: 'scale(1.2)' } },
          { delay: 50, style: { animationName: 'scale20', animationDuration: '46060ms' } },
        ],
      },

      nextStepId: 'infoSoudanOuEurope',
      textBackgroundColor: '#1D1003',
    },
    {
      ...base_choice_style,
      id: 'infoSoudanOuEurope',
      type: 'info',

      contentText:
        'Quel dilemme&thinsp;! Que ferais-tu, toi&thinsp;? <span class="background-underlined very-large">Suivrais-tu tes amies</span> vers l’Europe&thinsp;? Ou rest<span class="background-underlined large">erais-tu au Soudan?</span>',
      actionText: 'Je m’informe pour aider Senait à prendre la bonne décision :',
      actions: [
        {
          type: 'button',
          key: 'button-watch-1',
          text: 'J’écoute le témoignage d’un jeune Érythréen passé par Khartoum',
          buttonStyle: { '&:hover': { color: colors.violet } },
          icon: boutonRegarder,
          iconHover: boutonRegarderHoover,
          action: 'openDialog',
          dialogContent: {
            transition: 'slideUp',
            type: 'video',
            videoIframe: getYoutubeIframe('34YnuGrQn8g'),
          },
        },
      ],
      nextButtonStyle: {
        '&:hover': { color: colors.violet },
      },
      nextButtonText: 'Prendre une décision >',
      nextStepId: 'choiceSoudanOuEurope',
    },
    {
      ...base_choice_style,
      id: 'choiceSoudanOuEurope',
      type: 'choice',

      contentText:
        'Quel dilemme&thinsp;! Que ferais-tu, toi&thinsp;? <span class="background-underlined very-large">Suivrais-tu tes amies</span> vers l’Europe&thinsp;? Ou rest<span class="background-underlined large">erais-tu au Soudan?</span>',
      choices: [
        {
          type: 'button',
          key: 'button-1',
          text: 'Rester à Khartoum',
          buttonStyle: choiceButtonStyle,
          action: 'goNext',
          nextStepId: 'epilogue_soudan',
        },
        {
          type: 'button',
          key: 'button-2',
          text: "Continuer vers l'Europe",
          buttonStyle: choiceButtonStyle,
          action: 'goNext',
          nextStepId: 'SENAIT 08',
        },
      ],
    },
    //15
    {
      id: 'epilogue_soudan',

      ...base_epilogue,

      sound: SENAIT_FR_EPILOGUE1,
      sound_delay: epilogeAnimationTiming+epilogeSoundAdditionalDelay,
      sequence: [
        {
          delay: epilogeAnimationTiming,
          title: 'Voici à quoi ressemble ma vie au Soudan',
          text: 'Je continue de travailler comme domestique. Je me suis fait de nouveaux amis parmi les Érythréens qui vivent ici, et je me sens moins seule, même si je n’ai qu’un jour de libre par semaine pour les voir.<br/><br/>Comme on n’a pas de papiers, on est parfois à la merci de personnes qui en profitent, ou on peut être arrêtés. Je ne me sens donc pas en sécurité, mais on se soutient les uns les autres.<br/><br/>Ça me pèse aussi de ne pas pouvoir rêver d’une vie meilleure que d’être domestique, mais en même temps je suis heureuse de pouvoir soutenir ma famille en lui envoyant ce que je mets de côté.',
          textStyle: { left: '45vw' },
        },
      ],
      nextStepId: 'other_choices',
    },
    {
      id: 'other_choices',
      type: 'choice',

      ...base_choice_style,

      fixedImageBackground: baseBackgroundImg,

      fixedImageBackgroundStyle: {
        backgroundSize: '100% 100%',
        backgroundPosition: 'center',
        zIndex: 0,
      },

      contentStyle: {
        width: '100%',
        maxWidth: '500px',
        marginLeft: 'auto',
        marginRight: 'auto',
        color: 'white',
        zIndex: 100,
      },
      contentTextStyle: {
        textTransform: 'none',
        textAlign: 'center',
      },
      contentText: 'Voudrais-tu savoir ce qui se serait passé si tu avais fait <span class="background-underlined large white">d’autres choix&thinsp;?</span>',

      choices: [
        {
          type: 'button',
          key: 'button-1',
          text: 'Oui, je reviens au début du parcours',
          buttonStyle: otherChoiceButtonStyle,
          action: 'goNext',
          nextStepId: 'SENAIT 01',
        },
        {
          type: 'button',
          key: 'button-2',
          text: 'Non',
          buttonStyle: otherChoiceButtonStyle,
          action: 'goNext',
          nextStepId: '-1',
        },
      ],
    },
    {
      id: 'SENAIT 08',
      type: 'sequence',
      sound: SENAIT_FR_SEQ08,
      sound_delay: 50,
      sequence: [
        { type: 'text', text: 'D\u00e9j\u00e0 neuf jours dans ce d\u00e9sert, \nentass\u00e9 avec plus de 100 personnes sur ce camion. ', delay: 3190 },
        { type: 'text', text: 'Neuf jours de faim, de chaleur, de soif\u2026', delay: 4990 },
        { type: 'text', text: 'Surtout soif.. ', delay: 3960 },
        { type: 'text', text: 'Les deux bidons d\u2019eau par personne ne suffisent plus.', delay: 2030 },
        { type: 'text', text: 'Surtout pour Mehret qui vomit depuis des jours. ', delay: 2920 },
        { type: 'text', text: 'Elle est tellement faible qu\u2019elle glisse du camion. ', delay: 3020 },
        { type: 'text', text: 'On la r\u00e9cup\u00e8re de justesse. \nOn l\u2019accroche pour qu\u2019elle ne tombe plus. ', delay: 1990 },
        { type: 'text', text: 'Je demande de l\u2019eau au gens\u2026 \nmais c\u2019est trop tard je pense. ', delay: 3020 },
        { type: 'text', text: 'Mehret ne bouge plus. ', delay: 3030 },
        { type: 'text', text: 'Je panique. Je la secoue. \nRien n\u2019y fait. ', delay: 1900 },
        { type: 'text', text: 'Elle s\u2019\u00e9teint doucement, dans mes bras. ', delay: 2990 },
        { type: 'text', text: 'J\u2019ai envie d\u2019hurler.', delay: 2970 },
        { type: 'text', text: '', delay: 3990 },
        { type: 'goToNext', delay: 3010 },
      ],
      background: {
        src: desertImage,
        // style: { transition: 'transform linear' }, //transition: 'left linear, top linear, width linear, height linear'
        // animations: [
        //   { delay: 50, style: { transitionDuration: '20130ms', transform: 'scale(1.2)' } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        // ],

        style: { animationFillMode: 'forwards', animationTimingFunction: 'linear' },
        animations: [{ delay: 50, style: { animationName: 'scaleDown20', animationDuration: '20130ms' } }],
      },
      backgroundEffect: {
        style: { opacity: 0, backgroundColor: 'black' },
        animations: [{ delay: 50, style: { animationName: 'opacityNoneTo60', animationDuration: '20130ms' } }],
      },
      foreground: {
        src: main_chute,
        style: { height: '70%', position: 'relative', opacity: 0, transition: 'transform linear, opacity linear', transformOrigin: 'center', transform: 'translate(-20%, 20%)' },
        animations: [
          { delay: 20130, style: { animationName: 'opacityNoneToFull', animationDuration: '2000ms' } },
          { delay: 2000, style: { opacity: 1, animationName: 'animationSenait08_A', animationDuration: '8960ms' } },
          { delay: 8960, style: { animationName: 'opacityFullToNone', animationDuration: '7960ms', transform: 'translate(20%, -40%)' } },
        ],
      },

      nextStepId: 'SENAIT 13',
      textBackgroundColor: '#392223',
    },
    {
      id: 'SENAIT 13',
      type: 'sequence',
      sound: SENAIT_FR_SEQ13,
      sound_delay: 50,
      sequence: [
        { type: 'text', text: 'Je ne sais pas o\u00f9 je suis\u2026 ', delay: 10110 },
        { type: 'text', text: 'il n\u2019y a que le d\u00e9sert autour de nous\u2026 ', delay: 3050 },
        { type: 'text', text: 'J\u2019ai l\u2019impression que je suis sans vie, \nje ne ressens plus rien.', delay: 3950 },
        { type: 'text', text: 'Je n\u2019ai plus peur de mourir, \nje veux juste que \u00e7a s\u2019arr\u00eate. ', delay: 4940 },
        { type: 'text', text: 'On a \u00e9t\u00e9 kidnapp\u00e9s par des trafiquants, \navec tous les gens qui \u00e9taient sur le camion.', delay: 4990 },
        { type: 'text', text: 'Ils nous demandent 3000 euros chacun pour nous lib\u00e9rer. ', delay: 5040 },
        { type: 'text', text: 'Ils ont fait ce qu\u2019ils voulaient de moi.', delay: 6010 },
        { type: 'text', text: 'Ils ont appel\u00e9 ma m\u00e8re. Elle a tout entendu. ', delay: 3060 },
        { type: 'text', text: 'Elle les a suppli\u00e9s d\u2019arr\u00eater, elle a promis qu\u2019elle allait payer,', delay: 4870 },
        { type: 'text', text: ' qu\u2019elle allait appeler un oncle qui vit en Angleterre. ', delay: 2180 },
        { type: 'text', text: 'Depuis, ils me laissent en paix. ', delay: 4960 },
        { type: 'text', text: 'Certains sont ici depuis des mois, ', delay: 2930 },
        { type: 'text', text: 'ils attendent que la famille r\u00e9colte l\u2019argent et le transf\u00e8re. ', delay: 2010 },
        { type: 'text', text: 'On ne nous donne pas assez \u00e0 manger et \u00e0 boire et certains sont malades. ', delay: 4050 },
        { type: 'text', text: 'Une fille est enceinte.\nJe prie pour que ce ne soit pas mon cas.', delay: 5930 },
        { type: 'text', text: '', delay: 3970 },
        { type: 'goToNext', delay: 4030 },
      ],
      background: {
        src: darkWindow,
        // style: { transition: 'transform linear' },
        style: { animationFillMode: 'forwards', animationTimingFunction: 'linear' },
        animations: [{ delay: 50, style: { animationName: 'scale20', animationDuration: '34950ms' } }],
      },
      backgroundEffect: {
        style: { opacity: 0, backgroundColor: 'black', animationFillMode: 'forwards', animationTimingFunction: 'linear' },
        animations: [
          { delay: 50, style: { animationName: 'opacityNoneToFull', animationDuration: '34950ms' } },
          { delay: 34950, style: { animationName: 'opacityFullToNone', animationDuration: '37000ms' } },
        ],
      },
      foreground: {
        src: illu_viol,
        style: { height: '90vh', marginBottom: 'auto', objectPosition: 'right center', opacity: 0, transformOrigin: 'bottom center', animationTimingFunction: 'linear' },
        animations: [
          { delay: 35000, style: { animationName: 'opacityNoneToFull, scale100To107', animationDuration: '7000ms' } },
          { delay: 7000, style: { animationName: 'opacityFullToNone, scale107To120', animationDuration: '13000ms' } },
          // { delay: 11020, style: { transitionDuration: '10170ms', transform: 'scale(0.50)', opacity: 0 } },
        ],
      },
      nextStepId: 'SENAIT 14',
    },
    {
      id: 'SENAIT 09',
      type: 'sequence',
      sound: SENAIT_FR_SEQ09,
      sound_delay: 50,
      sequence: [
        { type: 'text', text: 'Heureusement ma m\u00e8re a \u00e9t\u00e9 lib\u00e9r\u00e9e \net mon oncle n\u2019est plus revenu. ', delay: 3030 },
        { type: 'text', text: 'Les ann\u00e9es ont pass\u00e9\n et j\u2019ai maintenant 16 ans.', delay: 3180 },
        { type: 'text', text: 'Comme tous les jeunes de mon \u00e2ge, on va venir me chercher cet \u00e9t\u00e9 ', delay: 2940 },
        { type: 'text', text: 'pour m\u2019emmener au camp militaire de Sawa. ', delay: 2900 },
        { type: 'text', text: 'Rien que d\u2019y penser, \u00e7a me donne des frissons. ', delay: 2980 },
        { type: 'text', text: 'Mes amis m\u2019ont racont\u00e9. ', delay: 2050 },
        { type: 'text', text: 'Et puis, comme je ne suis pas bonne \u00e9l\u00e8ve, apr\u00e8s mon service militaire, ', delay: 1940 },
        { type: 'text', text: 'je devrai rester dans l\u2019arm\u00e9e comme soldate ou pour les travaux publics. ', delay: 2190 },
        { type: 'text', text: 'Peut-\u00eatre pendant des ann\u00e9es. ', delay: 3820 },
        { type: 'text', text: 'Que faire&thinsp;? ', delay: 3010 },
        { type: 'text', text: 'Me cacher pour ne pas y aller&thinsp;? ', delay: 1180 },
        { type: 'text', text: 'Ma m\u00e8re m\u2019en a dissuad\u00e9. ', delay: 2870 },
        { type: 'text', text: 'Elle dit que c\u2019est une vie terrible de devoir se cacher toute sa vie. ', delay: 1110 },
        { type: 'text', text: 'Sinon, me marier et tomber enceinte pour \u00eatre dispens\u00e9e, \ncomme d\u2019autres filles&thinsp;? ', delay: 3970 },
        { type: 'text', text: 'Ou encore quitter le pays&thinsp;?', delay: 4950 },
        { type: 'text', text: '', delay: 2070 },
        { type: 'goToNext', delay: 2910 },
      ],
      background: {
        src: girlsWalking,
        style: { width: '120vw', position: 'relative', left: '-20vw' }, // transition: 'transform linear'
        animations: [
          { delay: 50, style: { animationDuration: '46180ms', animationName: 'translateX0To20vw' } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        ],
      },

      nextStepId: 'infoCampMilitaire',
    },
    //20
    {
      ...base_choice_style,
      id: 'infoCampMilitaire',
      type: 'info',

      contentText:
        'Quel dilemme! Que ferais-tu à ma place&thinsp;? <br/>Accepterais-tu d’aller au <span class="background-underlined medium">camp militaire</span> de Sawa, t<span class="background-underlined medium">e&nbsp;marierais-tu</span>, ou bien <span class="background-underlined large">fuirais-tu&nbsp;le&nbsp;pays&thinsp;?</span>',
      actionText: 'Je m’informe pour aider Senait à prendre la bonne décision :',
      actions: [
        {
          type: 'button',
          key: 'button-watch-1',
          text: 'J’écoute le témoignage d’une jeune fille qui a fui le service militaire',
          buttonStyle: { '&:hover': { color: colors.violet } },
          icon: boutonRegarder,
          iconHover: boutonRegarderHoover,
          action: 'openDialog',
          dialogContent: {
            transition: 'slideUp',
            type: 'video',
            videoIframe: getYoutubeIframe('ZH-LOnKNnPM'),
          },
        },
        {
          type: 'button',
          key: 'button-read',
          text: 'Je lis un rapport sur le service national en Érythrée',
          buttonStyle: { '&:hover': { color: colors.violet } },
          icon: boutonLire,
          iconHover: boutonLireHoover,
          action: 'openDialog',
          dialogContent: {
            transition: 'slideUp',
            backgroundImage: backgoundPurple,
            type: 'text',
            title: "Ils ne nous éduquent pas, ils nous mettent en esclavage<br/><span class='subtitle'>Rapport de Human Rights Watch sur le service national en Érythrée (résumé)</span>",
            text: "Depuis la guerre avec l'Éthiopie de la fin des années 1990, une grande partie de la population est largement prise en otage via le service national. Les recherches de Human Rights Watch montrent que de nombreux Érythréen·e·s ont passé toute leur vie professionnelle au service du gouvernement, dans des fonctions militaires ou civiles. <br/><br/>La situation « pas en guerre, pas en paix » a servi de prétexte au gouvernement Érythréen pour obliger tous les élèves de secondaire à se rendre au camp militaire de Sawa pour leur dernière année d’étude et pour suivre une formation militaire obligatoire. Chaque année, des milliers de jeunes, dont certains sont encore des enfants, sont acheminés de force de leur maison vers Sawa en bus.<br/><br/>À Sawa, les élèves sont soumis à des mauvais traitements et à des punitions sévères pour des infractions mineures, selon une discipline de type militaire, ainsi qu’au travail forcé. \"Ils font de nous des esclaves, au lieu de nous éduquer\", explique un ancien élève.<br/><br/>Après un an à Sawa, les jeunes sont, en grande partie sur base de leurs résultats aux examens, soit forcés de rejoindre l'armée, soit formés davantage pour être ensuite enrôlés dans des fonctions civiles au service du gouvernement, également pour une durée indéterminée.<br/><br/>Certains élèves abandonnent l'école pour échapper au service militaire, mais pour ensuite vivre dans la crainte des rafles notoires du gouvernement. De nombreuses filles optent pour le mariage et la maternité précoces comme moyen d'y échapper. Et fuir le pays comporte de risques importants, tant à l'intérieur de l'Érythrée – emprisonnement et mauvais traitements en cas d’arrestation – que sur les routes migratoires.<br/><br/>Ceci est un résumé du rapport de Human Rights Watch <a href='https://www.hrw.org/report/2019/08/08/they-are-making-us-slaves-not-educating-us/how-indefinite-conscription-restricts' target='_blank'>&#8220They Are Making Us into Slaves, Not Educating Us&#8221 : How Indefinite Conscription Restricts Young People’s Rights, Access to Education in Eritrea</a> publié le 8 août 2019.",
          },
        },
      ],
      nextButtonStyle: {
        '&:hover': { color: colors.violet },
      },
      nextButtonText: 'Prendre une décision >',
      nextStepId: 'choice camp militaire',
    },
    {
      id: 'choice camp militaire',
      type: 'choice',

      ...base_choice_style,
      contentText:
        'Quel dilemme. Que ferais-tu à ma place&thinsp;? <br/>Accepterais-tu d’aller au <span class="background-underlined medium">camp militaire</span> de Sawa, t<span class="background-underlined medium">e&nbsp;marierais-tu</span>, ou bien <span class="background-underlined large">fuirais-tu&nbsp;le&nbsp;pays&thinsp;?</span>',
      choices: [
        {
          type: 'button',
          key: 'button-1',
          text: 'Se marier et avoir un enfant',
          buttonStyle: choiceButtonStyle,
          action: 'fakeChoice',
          actionText: 'Les parents de mon meilleur ami ne veulent pas qu’on se marie à cause de mon père et de nos mésaventures: ils ont peur d’ avoir des problèmes.',
          actionTextStyle: { backgroundImage: `url(${blockBlancFakeChoiceSmall})`, maxHeight: '60vh', width: '30vw', maxWidth: '400px' },
        },
        {
          type: 'button',
          key: 'button-2',
          text: 'Aller au camp militaire',
          buttonStyle: choiceButtonStyle,
          action: 'goNext',
          nextStepId: 'epilogue_militaire',
        },
        {
          type: 'button',
          key: 'button-3',
          text: "Quitter l'Érythrée",
          buttonStyle: choiceButtonStyle,
          action: 'goNext',
          nextStepId: 'map2',
        },
      ],
    },
    {
      id: 'epilogue_militaire',

      ...base_epilogue,

      sound: SENAIT_FR_EPILOGUE_MILITAIRE,
      sound_delay: epilogeAnimationTiming+epilogeSoundAdditionalDelay,
      sequence: [
        {
          delay: epilogeAnimationTiming,
          title: 'Voici à quoi ressemble ma vie dans l’armée',
          text: 'J’ai terminé ma formation militaire, et je suis en service comme soldate depuis déjà plusieurs années qui me semblent interminables. J’aurais préféré être infirmière, ou n’importe quel métier qui n’implique pas de violence, et pouvoir vivre dans mon village. Je n’ai pas cette liberté, ni aucune autre. Mais au moins je suis en vie. Je prie pour qu’il n’y ait pas de reprise de violence avec l’Éthiopie.<br/><br/>Ma famille me manque beaucoup. Nous avons peu de permissions, et chaque retrouvaille est une grande joie.',
          textStyle: { left: '45vw' },
        },
      ],
      nextStepId: 'other_choices',
    },
    {
      id: 'map2',
      type: 'map',
      background: baseBackgroundImg,
      mapImage: map2,
      mapContainerClass: 'cursor-gray',
      nextStepDelay: 3500,
      nextStepId: 'SENAIT 10',
    },
    {
      id: 'SENAIT 10',
      type: 'sequence',
      sound: SENAIT_FR_SEQ10,
      sound_delay: 50,
      sequence: [
        { type: 'text', text: '\u00c7a fait trois mois que je suis arriv\u00e9e \u00e0 Shire, \ndans la r\u00e9gion du Tigr\u00e9. ', delay: 2020 },
        { type: 'text', text: 'C\u2019est une petite ville pr\u00e8s de la fronti\u00e8re \no\u00f9 vivent beaucoup d\u2019Érythr\u00e9ens. ', delay: 4060 },
        { type: 'text', text: 'Mais les probl\u00e8mes ont recommenc\u00e9 entre l\u2019\u00c9rythr\u00e9e et l\u2019\u00c9thiopie. ', delay: 3930 },
        { type: 'text', text: 'Il y a des violences dans toute la r\u00e9gion. ', delay: 3060 },
        { type: 'text', text: 'Beaucoup de gens fuient vers les camps de r\u00e9fugi\u00e9s au Soudan, ', delay: 1970 },
        { type: 'text', text: 'mais on me dit qu\u2019il n\u2019y pas de perspectives l\u00e0-bas.', delay: 2060 },
        { type: 'text', text: 'D\u2019autres vont vers la capitale, Addis-Abeba, ', delay: 2960 },
        { type: 'text', text: 'mais c\u2019est dangereux l\u00e0-bas pour l\u2019instant pour les Érythr\u00e9ens.', delay: 2160 },
        { type: 'text', text: '', delay: 6890 },
        { type: 'goToNext', delay: 3060 },
      ],
      background: {
        src: greenSkirt,
        style: { transform: 'scale(1.2)', transition: 'transform linear' },
        animations: [
          { delay: 50, style: { animationDuration: '32120ms', animationName: 'scaleDown20' } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        ],
      },
      textBackgroundColor: '#51351D',
      nextStepId: 'info after shire',
    },
    //25
    {
      ...base_choice_style,
      id: 'info after shire',
      type: 'info',

      contentText:
        '<span class="background-underlined medium">Que ferais-tu</span> si c’était toi&thinsp;?<br/>Irais-tu te <span class="background-underlined large">réfugier au Soudan</span> ou <span class="background-underlined very-large">rejoindrais-tu&nbsp;la&nbsp;capitale&thinsp;?</span>',
      actionText: 'Je m’informe pour aider Senait à prendre la bonne décision :',
      actions: [
        {
          type: 'button',
          key: 'button-read',
          text: 'Je découvre un reportage sur les Érythréen·ne·s qui fuient le Tigré ',
          buttonStyle: { '&:hover': { color: colors.violet } },
          icon: boutonLire,
          iconHover: boutonLireHoover,
          action: 'openDialog',
          dialogContent: {
            transition: 'slideUp',
            backgroundImage: backgoundPurple,
            type: 'text',
            title:
              "Les Érythréen·ne·s du Tigré face à un nouvel exil<br/><span class='subtitle'><a href='https://fr.africanews.com/2020/12/12/soudan-le-nouvel-exil-des-refugies-erythreens-en-ethiopie/' target='_blank'>Regarder le reportage vidéo à la place de l’article?</a></span>",
            text: 'Parmi les milliers de personnes qui traversent la frontière en direction du Soudan pour fuir les combats dans la région du Tigré, certaines connaissaient déjà l’exil. Elles avaient fui l’Érythrée pour échapper à la répression et la conscription obligatoire, et avaient trouvé refuge au Tigré.<br/><br/>Après avoir été officiellement en guerre pendant des années, l’Éthiopie et l’Érythrée avaient signé la paix en 2018 lorsque le Premier ministre d\'Éthiopie avait écarté du pouvoir le Front de libération du peuple du Tigré, ennemi juré du président Érythréen. Suite à ce changement d’alliance étonnant, le Premier ministre Éthiopien a lancé une offensive dans la région dissidente du Tigré, et les Érythréen·ne·s qui bénéficiaient depuis longtemps d’une protection en Éthiopie semblent être devenu·e·s une cible.<br/><br/>On parle notamment d’attaques contre les camps de réfugié·e·s&thinsp;: « Des soldats sont rentrés dans notre camp et ont commencé à tirer sur tout le monde - hommes, femmes et enfants » explique un réfugié Érythréen qui a perdu la trace de sa femme et ses enfants dans ce chaos. « Certains soldats étaient Érythréens, d’autres Éthiopiens » ajoute-t-il. Avec le rétablissement des relations entre l\'Éthiopie et l\'Érythrée, il se peut que l\'Érythrée ne veuille plus que l\'Éthiopie accueille des dissidents ou des déserteurs de l’armée, selon un analyste.<br/><br/>L’agence de l’ONU pour les réfugiés (HCR) est profondément préoccupée par le sort des réfugié·e·s érythréen·ne·s encore en Éthiopie. Ils ont reçu un nombre important de rapports faisant état de personnes tuées et enlevées dans les camps, et renvoyées de force en Érythrée.<br/><br/>Cet article fictif est inspiré du reportage d’Africanews <a href="https://fr.africanews.com/2020/12/12/soudan-le-nouvel-exil-des-refugies-erythreens-en-ethiopie/" target="_blank">« Soudan&thinsp;: le nouvel exil des réfugiés érythréens en Éthiopie »</a> publié le 12 décembre 2020.<br/>',
          },
        },
      ],
      nextButtonStyle: {
        '&:hover': { color: colors.violet },
      },
      nextButtonText: 'Prendre une décision >',
      nextStepId: 'choice after shire',
    },
    {
      id: 'choice after shire',
      type: 'choice',

      ...base_choice_style,
      contentText:
        '<span class="background-underlined medium">Que ferais-tu</span> si c’était toi&thinsp;?<br/>Irais-tu te <span class="background-underlined large">réfugier au Soudan</span> ou <span class="background-underlined very-large">rejoindrais-tu&nbsp;la&nbsp;capitale&thinsp;?</span>',
      choices: [
        {
          type: 'button',
          key: 'button-1',
          text: 'Tenter ma chance à la capitale',
          buttonStyle: choiceButtonStyle,
          action: 'fakeChoice',
          actionText:
            'Beaucoup d’Érythréens sont arrivés les dernières semaines à Addis-Abeba. C’est très difficile de trouver un endroit pour dormir et du travail. Et puis il y a des rafles et le risque d’être arrêté et ramené en Érythrée. Je préfère quand même aller vers les camps au Soudan. Au moins, je pourrai être en sécurité et survivre le temps que ça se calme dans le Tigré.',
          actionTextStyle: { backgroundImage: `url(${blockBlancFakeChoiceMedium})`, maxHeight: '60vh', width: '40vw', maxWidth: '500px' },
        },
        {
          type: 'button',
          key: 'button-2',
          text: 'Se rendre dans un camp au Soudan',
          buttonStyle: choiceButtonStyle,
          action: 'goNext',
          nextStepId: 'SENAIT 11',
        },
      ],
    },
    {
      id: 'SENAIT 11',
      type: 'sequence',
      sound: SENAIT_FR_SEQ11,
      sound_delay: 50,
      sequence: [
        { type: 'text', text: '\u00c7a fait d\u00e9j\u00e0 deux mois que je suis dans le camp de r\u00e9fugi\u00e9s. ', delay: 2140 },
        { type: 'text', text: 'Les violences dans le Tigr\u00e9 se prolongent. ', delay: 3000 },
        { type: 'text', text: 'On se rend compte qu\u2019on ne pourra \npeut-\u00eatre pas y retourner avant un moment. ', delay: 2940 },
        { type: 'text', text: 'Mais quel avenir si je reste ici&thinsp;?', delay: 3040 },
        { type: 'text', text: 'Il n\u2019y a presque pas d\u2019\u00e9cole, pas de travail, \net je suis loin des miens.', delay: 2940 },
        { type: 'text', text: 'Et je ne me sens pas en s\u00e9curit\u00e9. \nOn dit qu\u2019il a des enl\u00e8vements. ', delay: 3110 },
        { type: 'text', text: 'Plusieurs jeunes veulent essayer d\u2019aller en Libye.', delay: 3920 },
        { type: 'text', text: '', delay: 3040 },
        { type: 'goToNext', delay: 4050 },
      ],
      background: {
        src: campSoudan,
        // style: { transform: 'scale(1.2)', transition: 'transform linear' },
        // // animations: [
        // //   { delay: 50, style: { transitionDuration: '32120ms', transform: 'scale(1)' } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        // // ],
      },
      textBackgroundColor: '#81736A',
      nextStepId: 'mapIncoherence1',
    },
    {
      id: 'SENAIT 12',
      type: 'sequence',
      sound: SENAIT_FR_SEQ12,
      sound_delay: 50,
      sequence: [
        { type: 'text', text: 'Les passeurs nous font attendre dans un b\u00e2timent pr\u00e8s de Khartoum. ', delay: 1180 },
        { type: 'text', text: 'Un premier camion a pu partir.', delay: 3960 },
        { type: 'text', text: 'Mes amis du camp sont mont\u00e9s dedans, mais il n\u2019y avait pas de place pour moi. ', delay: 1910 },
        { type: 'text', text: 'Cela fait maintenant un mois que j\u2019attends mon tour, ', delay: 3950 },
        { type: 'text', text: 'et je suis \u00e9nerv\u00e9e de ne pas avoir pu monter. ', delay: 2210 },
        { type: 'text', text: 'Mais ce matin j\u2019ai appris une terrible nouvelle&thinsp;:', delay: 2980 },
        { type: 'text', text: 'les gens du premier camion se sont fait kidnapper \npar la mafia, dans le d\u00e9sert... ', delay: 2000 },
        { type: 'text', text: '\u00catre kidnapp\u00e9, je sais ce que \u00e7a veut dire. ', delay: 4880 },
        { type: 'text', text: 'Tout le monde ici sait ce que \u00e7a veut dire. ', delay: 2080 },
        { type: 'text', text: 'Et \u00e7a me glace le sang.', delay: 1930 },
        { type: 'text', text: 'En m\u00eame temps, si je fais marche arri\u00e8re, \nje perds l\u2019argent que j\u2019ai d\u00e9j\u00e0 pay\u00e9. ', delay: 2080 },
        { type: 'text', text: '', delay: 4940 },
        { type: 'goToNext', delay: 4940 },
      ],
      background: {
        src: batimentRoute,
        // style: { transform: 'scale(1.2)', transition: 'transform linear' },
        // // animations: [
        // //   { delay: 50, style: { transitionDuration: '32120ms', transform: 'scale(1)' } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        // // ],
      },
      textBackgroundColor: '#1A1A18',
      nextStepId: 'info after 12',
    },
    {
      ...base_choice_style,
      id: 'info after 12',
      type: 'info',

      contentText:
        'Je ne sais vraiment pas quoi faire. Que ferais-tu, si c’était toi&thinsp;?<br/>Prendrais-tu le pr<span class="background-underlined medium">ochain camion</span> malgré le risque <span class="background-underlined very-large">ou&nbsp;retournerais-tu&nbsp;au&nbsp;camp</span>&thinsp;?',
      actionText: 'Je m’informe pour aider Senait à prendre la bonne décision :',
      actions: [
        {
          type: 'button',
          key: 'button-watch-2',
          text: 'J’écoute le témoignage d’un jeune Érythréen passé par la Libye',
          buttonStyle: { '&:hover': { color: colors.violet } },
          icon: boutonRegarder,
          iconHover: boutonRegarderHoover,
          action: 'openDialog',
          dialogContent: {
            transition: 'slideUp',
            type: 'video',
            videoIframe: getYoutubeIframe('5ElM_O_5mh8'),
          },
        },
        {
          type: 'button',
          key: 'button-read',
          text: 'Je lis un article sur le sort des Érythréens sur les routes migratoires',
          buttonStyle: { '&:hover': { color: colors.violet } },
          icon: boutonLire,
          iconHover: boutonLireHoover,
          action: 'openDialog',
          dialogContent: {
            transition: 'slideUp',
            backgroundImage: backgoundPurple,
            type: 'text',
            title: "Le voyage périlleux vers un nouveau chez-soi<br/><span class='subtitle'>MO<sup>*</sup> magazine (résumé de l’article original)</span>",
            text: 'Enlèvements avec rançon, marchés d’esclaves Libyens, traversée périlleuse de la méditerranée... Pourquoi les réfugié·e·s érythréen·ne·s apparaissent-ils et elles souvent dans les drames migratoires les plus inhumains?<span class="inline-title">« Corée du Nord de l’Afrique »</span>Les réfugié·e·s Érythréen·ne·s ont clairement droit à l’asile, et sont même le groupe avec le plus haut taux de protection en Europe. Ce n’est pas pour rien que ce pays a reçu le surnom de « Corée du Nord de l’Afrique ». Depuis son indépendance il y a 25 ans, l’Érythrée est devenu le pays le moins libre d’Afrique sub-saharienne&thinsp;: Le seul destin d’un journaliste y est la prison, les partis politiques et la société civile sont interdits et il n’existe pas de justice indépendante. <br/><br/>L’autre similarité avec la Corée du Nord est le service militaire sans fin, qui se transforme souvent en travail forcé: En plus de l’absence de liberté politique, le service militaire illimité te prive aussi de la liberté personnelle de construire ta propre vie. <span class="inline-title">Traite des êtres humains</span>Il y a peu de doute que les Érythréen·ne·s aient de bonnes raisons de fuir le pays, mais cela ne signifie pas qu’ils et elles trouvent facilement un nouveau ‘chez soi’. Plus encore que les autres réfugiés, les Érythréen·ne·s semblent très vulnérables à l’exploitation de trafiquants d\'êtres humains qui les ont en ligne de mire. Ce trafic commence en Érythrée-même: Comme il est punissable de quitter l’Érythrée, celui qui veut partir doit déjà y payer des passeurs internes. <br/><br/>Comme souvent, la plupart ne vont pas plus loin que les pays voisins. Environ 250.000 Érythréen·ne·s se trouvent dans des camps de réfugié·e·s au Soudan et en Éthiopie. Certains aspirent à une solution plus durable: Une vie dans ces ‘zones d’attente’ n’offre que peu de perspectives d’avenir. Par ailleurs, nombre d’entre eux ne se sentent pas en sécurité dans les camps. Des enlèvements y auraient lieu, impliquant des agents de sécurité et des bandes armées qui demandent des rançons aux familles.<br/><br/>Jusque 2013, la route Egyptienne vers Israël était la plus empruntée, mais beaucoup tombaient entre les mains -à nouveau- de kidnappeurs dans le désert du Sinaï. Leurs familles recevaient des appels épouvantables où elles entendaient leur proche être torturé ou violé. Si elles ne réussissaient pas à rassembler la somme d’argent demandée, la victime était tuée. <br/><br/>Depuis, la route Libyenne est montée en popularité. Et ce malgré la guerre civile, car les milices libyennes ont compris que le trafic de réfugiés était une source de revenu intéressante. La route via la Libye est donc chère et très dangereuse. Une fois de plus, ce sont « principalement des Érythréen·ne·s » qui étaient concerné·e·s quand le monde a découvert les marchés d’esclaves libyens. <br/><br/>Ceci est un résumé d’extraits de l’article de MO* Magazine <a href="https://www.mo.be/analyse/waarom-eritree-rs-zo-vaak-opduiken-vluchtelingenverhalen" target="_blank">« Waarom Eritreeërs steeds opduiken in onmenselijke vluchtverhalen »</a> publié le 11 septembre 2018.',
          },
        },
      ],
      nextButtonStyle: {
        '&:hover': { color: colors.violet },
      },
      nextButtonText: 'Prendre une décision >',
      nextStepId: 'choice after 12',
    },
    //30
    {
      id: 'choice after 12',
      type: 'choice',

      ...base_choice_style,
      contentText:
        'Je ne sais vraiment pas quoi faire. Que ferais-tu, si c’était toi&thinsp;?<br/>Prendrais-tu le pr<span class="background-underlined medium">ochain camion</span> malgré le risque <span class="background-underlined very-large">ou&nbsp;retournerais-tu&nbsp;au&nbsp;camp</span>&thinsp;?',
      choices: [
        {
          type: 'button',
          key: 'button-1',
          text: 'Faire marche arrière',
          buttonStyle: choiceButtonStyle,
          action: 'showConfirmation',
          confirmationContent: {
            title:
              'Es-<span class="background-underlined medium">tu certain-e</span>&thinsp;?<br/>Je n’ai pas envie de passer ma vie dans une <span class="background-underlined very-large">prison à ciel ouvert</span>.',
            buttons: [
              {
                text: 'Oui, je suis<br/>sûr&middot;e de moi',
                buttonStyle: choiceButtonStyle,
                action: 'goNext',
                nextStepId: 'epilogue tente',
              },
              {
                text: 'Je reviens<br/>sur ma décision',
                buttonStyle: choiceButtonStyle,
                action: 'closeConfirmation',
              },
            ],
          },
        },
        {
          type: 'button',
          key: 'button-2',
          text: 'Prendre le prochain camion',
          buttonStyle: choiceButtonStyle,
          action: 'showConfirmation',
          confirmationContent: {
            title: 'Es-<span class="background-underlined medium">tu certain-e</span>&thinsp;?<br/>Si je me fais kidnapper, il peut m’arriver des choses terribles',
            buttons: [
              {
                text: 'Oui, je suis<br/>sûr&middot;e de moi',
                buttonStyle: choiceButtonStyle,
                action: 'goNext',
                nextStepId: 'map lybie from soudan',
              },
              {
                text: 'Je reviens<br/>sur ma décision',
                buttonStyle: choiceButtonStyle,
                action: 'closeConfirmation',
              },
            ],
          },
        },
      ],
    },
    {
      id: 'epilogue tente',

      ...base_epilogue,

      sound: SENAIT_FR_EPILOGUE_3,
      sound_delay: epilogeAnimationTiming+epilogeSoundAdditionalDelay,
      sequence: [
        {
          delay: epilogeAnimationTiming,
          title: 'Voici à quoi ressemble ma vie dans les camps de réfugiés',
          text: "Les violences au Tigré ont cessé et je suis retournée en Éthiopie, dans un autre camp de réfugiés. Et malheureusement, les camps se ressemblent&thinsp;: il n'y a pas d'avenir, juste le quotidien qui se répète éternellement. Comme si la vie était en pause. Moi qui ai tellement d'envies, c'est difficile à vivre. Mais au moins je suis en sécurité et en vie, et je suis déjà reconnaissante pour ça. J'espère surtout pouvoir un jour retrouver ma famille. ",
          textStyle: { left: '45vw' },
        },
      ],
      nextStepId: 'other_choices',
    },
    {
      id: 'map lybie from soudan',
      type: 'map',
      background: baseBackgroundImg,
      mapImage: map3,
      mapContainerClass: 'cursor-gray',
      nextStepDelay: 3500,
      nextStepId: 'SENAIT 13',
    },
    {
      id: 'SENAIT 14',
      type: 'sequence',
      sound: SENAIT_FR_SEQ14,
      sound_delay: 50,
      sequence: [
        { type: 'text', text: 'Mon oncle a transf\u00e9r\u00e9 l\u2019argent, \net je suis enfin libre. ', delay: 1040 },
        { type: 'text', text: 'Mais je peux de nouveau \u00eatre arr\u00eat\u00e9e ou kidnapp\u00e9e \ntant que je suis en Libye. ', delay: 2990 },
        { type: 'text', text: 'Ce pays est un enfer pour les gens comme moi. ', delay: 3160 },
        { type: 'text', text: 'Il faut que je parte d\u2019ici.', delay: 2970 },
        { type: 'text', text: 'Mais o\u00f9 aller&thinsp;?', delay: 2860 },
        { type: 'text', text: 'Soit je retourne dans le camp au Soudan. \nSoit je continue vers l\u2019Europe.', delay: 1050 },
        { type: 'text', text: 'Je ne veux pas prendre un canot pneumatique \ncar j\u2019ai entendu parler de naufrages. ', delay: 4020 },
        { type: 'text', text: 'Mais les bateaux en bois coûtent cher\net je n\u2019ai plus d\u2019argent.', delay: 3950 },
        { type: 'text', text: 'Les passeurs me proposent un deal&thinsp;: ', delay: 3050 },
        { type: 'text', text: 'travailler pour eux pendant quelques mois \ncontre une place sur un bateau en dur. ', delay: 2060 },
        { type: 'text', text: '', delay: 4850 },
        { type: 'goToNext', delay: 1170 },
      ],
      background: {
        src: beach,
        // style: {
        //   width: '100vw',
        //   height: 'auto',
        //   // position: 'relative',
        //   '--minShift': 'calc(-75vw + 50vh)',
        //   '--maxShift': 'calc(-150vw + 100vh)',
        //   '--deltaShift': 'calc( var(--maxShift) - var(--minShift))',
        //   // top: 'calc(-75vw + 50vh)',
        //   objectFit: 'fill',
        //   objectPosition: 'none',
        //   transition: 'transform ease-in-out',
        //   '--shiftRatio': 0,
        //   transform: 'translateY( calc(var(--minShift) + var(--shiftRatio)*var(--deltaShift)))',
        // },
        // animations: [
        //   { delay: 50, style: { transitionDuration: '7250ms', '--shiftRatio': 0.3 } },
        //   { delay: 7050, style: { transitionDuration: '7000ms', '--shiftRatio': 0.2 } },
        //   { delay: 7000, style: { transitionDuration: '7000ms', '--shiftRatio': 0.5 } },
        //   { delay: 7000, style: { transitionDuration: '7000ms', '--shiftRatio': 0.1 } },
        //   { delay: 7000, style: { transitionDuration: '7000ms', '--shiftRatio': 0.8 } },
        // ],
        style: { animationFillMode: 'forwards', animationTimingFunction: 'linear' },
        animations: [{ delay: 50, style: { animationName: 'scale20', animationDuration: '33120ms' } }],
      },
      backgroundEffect: {
        style: { opacity: 1, backgroundColor: 'black', transition: 'opacity linear' },
        animations: [
          { delay: 50, style: { animationName: 'opacityFullToNone', animationDuration: '1950ms' } },
          { delay: 31170, style: { animationName: 'opacityNoneToFull', animationDuration: '2000ms' } },
        ],
      },
      textBackgroundColor: '#796765',
      nextStepId: 'info bateau pneumatique',
    },
    {
      ...base_choice_style,
      id: 'info bateau pneumatique',
      type: 'info',

      contentText:
        'C’est vraiment une décision difficile. Toi, que ferais-tu&thinsp;?<br/>Ferais-tu <span class="background-underlined large">marche arrière</span>, ou continuerais-tu <span class="background-underlined medium">vers l’Europe</span> sur un bateau pneumatique&thinsp;? Ou bien accepterais-tu le <span class="background-underlined large">deal des passeurs</span> pour un bateau en bois&thinsp;?',
      actionText: 'Je m’informe pour aider Senait à prendre la bonne décision :',
      actions: [
        {
          type: 'button',
          key: 'button-read',
          text: 'Je lis un rapport sur la situation des migrants en Libye',
          buttonStyle: { '&:hover': { color: colors.violet } },
          icon: boutonLire,
          iconHover: boutonLireHoover,
          action: 'openDialog',
          dialogContent: {
            transition: 'slideUp',
            backgroundImage: backgoundPurple,
            type: 'text',
            title: "‘Entre la vie et la mort’: Réfugié·e·s et migrant·e·s piégés dans un cycle de violence en Libye<br/><span class='subtitle'>Rapport d’Amnesty International (résumé)</span>",
            text: "En Libye, les personnes réfugiées et migrantes sont piégées dans un cycle de violences et de graves atteintes aux droits humains, telles que la détention arbitraire prolongée, la torture et d'autres mauvais traitements, les homicides, le viol, le travail forcé et l'exploitation aux mains d'agents gouvernementaux et non gouvernementaux, dans un climat d'impunité quasi totale. <br/><br/>Le sort tragique des personnes réfugiées et migrantes en Libye s'inscrit dans un contexte de conflit armé, d'insécurité et d'état de non-droit persistants. Malgré cela, l'Union européenne (UE), désireuse de réduire le nombre d’arrivées en Europe, continue de mener des politiques qui piègent les milliers de migrant·e·s et réfugié·e·s en Libye. En particulier, le soutien aux garde-côtes libyens pour intercepter les personnes qui tentent la traversée et les débarquer en Libye mène à la détention arbitraire à durée indéterminée et à la disparition forcée de milliers d’entre eux.<br/><br/>Les réfugié·e·s et migrant·e·s en Libye sont constamment exposés au risque d’être arrêtés ou enlevés par les forces de sécurité, des milices, des groupes armés, des trafiquants, ou d'autres personnes impliquées dans des activités criminelles. Les personnes interrogées pour ce rapport ont toutes été arrêtées -sans décision judiciaire et sans possibilité de contester la légalité de leur détention- ou enlevées au moins une fois. Toutes avaient fait au moins une fois l'objet d'une demande de rançon, et avaient été torturées, violées ou affamées jusqu'à ce que leur famille rassemble la somme demandée. Nombre d’entre eux déclarent avoir assisté à la mort d'amis, de membres de leur famille ou d'autres personnes détenues.<br/><br/>Même quand ils ne sont pas détenus, les réfugié·e·s et migrant·e·s restent vulnérables aux abus et à l'exploitation systématique de la part de groupes armés et de milices, ou d’employeurs peu scrupuleux, contre lesquels ils sont dans l’impossibilité de demander une protection.<br/><br/>De milliers de femmes, d'hommes et d'enfants piégés dans des conditions atroces en Libye n’ont guère le choix que de tenter la traversée périlleuse de la Méditerranée – avec tous les risques que cela comporte. Nombre d’entre elles sont interceptées par les garde-côtes libyens et ramenées en Libye, où les attendent le même cycle de violences.<br/>Pour briser ce cycle de violences, les autorités libyennes doivent cesser les détentions arbitraires et indéterminées des réfugié·e·s et migrant·e·s, et l’UE doit complètement revoir sa coopération avec la Libye en matière de migration.<br/><br/>Ceci est un résumé du rapport d’Amnesty International <a href='https://www.amnesty.org/fr/documents/mde19/3084/2020/fr/' target='_blank'>«Entre la vie et la mort&thinsp;: Les personnes réfugiées et migrantes prises dans la tourmente des violences en Libye »</a> publié en 2020.<br/>",
          },
        },
        {
          type: 'button',
          key: 'button-watch-1',
          text: 'J’écoute une jeune Érythréenne qui raconte la traversée',
          buttonStyle: { '&:hover': { color: colors.violet } },
          icon: boutonRegarder,
          iconHover: boutonRegarderHoover,
          action: 'openDialog',
          dialogContent: {
            transition: 'slideUp',
            type: 'video',
            videoIframe: getYoutubeIframe('6_XYh0xuHD0'),
          },
        },
      ],
      nextButtonStyle: {
        '&:hover': { color: colors.violet },
      },
      nextButtonText: 'Prendre une décision >',
      nextStepId: 'choice bateau pneumatique',
    },
    //35
    {
      id: 'choice bateau pneumatique',
      type: 'choice',

      ...base_choice_style,
      contentText:
        'C’est vraiment une décision difficile. Toi, que ferais-tu&thinsp;?<br/>Ferais-tu <span class="background-underlined large">marche arrière</span>, ou continuerais-tu <span class="background-underlined medium">vers l’Europe</span> sur un bateau pneumatique&thinsp;? Ou bien accepterais-tu le <span class="background-underlined large">deal des passeurs</span> pour un bateau en bois&thinsp;?',
      choices: [
        {
          type: 'button',
          key: 'button-1',
          text: 'Retourner au Soudan',
          buttonStyle: choiceButtonStyle,
          action: 'goNext',
          nextStepId: 'map soudan from lybie',
        },
        {
          type: 'button',
          key: 'button-2',
          text: 'Accepter le deal des passeurs',
          buttonStyle: choiceButtonStyle,
          action: 'fakeChoice',
          actionText:
            "J'ai été arrêtée par la police pendant que je travaillais, et j'ai été amenée dans une prison libyenne. Mais les gardes de la prison ont été approchés par la mafia pour nous \"racheter\", et on nous a ramenés au même endroit dans le désert. J'ai à nouveau dû payer. Il faut que je quitte cet enfer, coûte que coûte&thinsp;! Je prends un bateau pneumatique, je m'en fous si je meurs, tant que je pars d'ici immédiatement. ",
          actionTextStyle: { backgroundImage: `url(${blockBlancFakeChoiceMedium})`, maxHeight: '60vh', width: '40vw', maxWidth: '500px' },
        },
        {
          type: 'button',
          key: 'button-3',
          text: 'Traverser au plus vite sur un bateau pneumatique',
          buttonStyle: choiceButtonStyle,
          action: 'goNext',
          nextStepId: 'SENAIT 15',
        },
      ],
    },
    {
      id: 'map soudan from lybie',
      type: 'map',
      background: baseBackgroundImg,
      mapImage: map4,
      mapContainerClass: 'cursor-gray',
      nextStepDelay: 3500,
      nextStepId: 'mapIncoherence2',
    },
    {
      id: 'SENAIT 15',
      type: 'sequence',
      sound: SENAIT_FR_SEQ15,
      sound_delay: 50,
      sequence: [
        { type: 'text', text: 'La travers\u00e9e en mer a \u00e9t\u00e9 un cauchemar. ', delay: 3020 },
        { type: 'text', text: 'C\u2019est en cachette que les passeurs nous ont fait monter sur le bateau la nuit. ', delay: 2170 },
        { type: 'text', text: 'Nous \u00e9tions 23, beaucoup trop pour ce petit bateau pneumatique. ', delay: 3990 },
        { type: 'text', text: 'Nous avons pri\u00e9 pour ne pas rencontrer ni de gardes-c\u00f4tes, ', delay: 4820 },
        { type: 'text', text: 'ni de temp\u00eate, car je ne sais pas nager. ', delay: 2110 },
        { type: 'text', text: 'A un moment, le bateau est tomb\u00e9 en panne d\u2019essence.', delay: 2970 },
        { type: 'text', text: 'Nous \u00e9tions au milieu de la mer\n et nous ne pouvions rien faire, rien\u2026', delay: 2100 },
        { type: 'text', text: 'Juste attendre\u2026 ', delay: 3890 },
        { type: 'text', text: 'et esp\u00e9rer qu\u2019un bateau passe par l\u00e0. ', delay: 2000 },
        { type: 'text', text: 'C\u2019\u00e9tait les deux jours les plus longs de ma vie.', delay: 2930 },
        { type: 'text', text: 'Et puis\u2026 un bateau nous a secourus.', delay: 3030 },
        { type: 'text', text: '', delay: 4970 },
        { type: 'goToNext', delay: 1170 },
      ],
      background: {
        src: baseBackgroundImg, // medecinBateau,
        // style: {
        //   width: '100vw',
        //   height: 'auto',
        //   position: 'relative',
        //   top: 'calc(-75vw + 50vh)',
        //   objectFit: 'fill',
        //   objectPosition: 'none',
        //   transition: 'top ease-in-out',
        // },
        // animations: [
        //   { delay: 50, style: { transitionDuration: '6000ms', top: 'calc(-85vw + 50vh)' } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        //   { delay: 6000, style: { transitionDuration: '3500ms', top: 'calc(-80vw + 50vh)' } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        //   { delay: 3500, style: { transitionDuration: '3500ms', top: 'calc(-90vw + 50vh)' } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        //   { delay: 3500, style: { transitionDuration: '3500ms', top: 'calc(-80vw + 50vh)' } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        //   { delay: 3500, style: { transitionDuration: '3500ms', top: 'calc(-105vw + 50vh)' } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        // ],
      },
      foreground: {
        src: bateau_pneumatique,
        style: { width: '100vw', animationFillMode: 'forwards', animationTimingFunction: 'linear', opacity:0 },
        animations: [{ delay: 50, style: { animationName: 'animationSenaitBateau', animationDuration: '39120ms' } }],
      },
      textBackgroundColor: '#222726',
      nextStepId: 'map to italy',
    },
    {
      id: 'map to italy',
      type: 'map',
      background: baseBackgroundImg,
      mapImage: map5,
      mapContainerClass: 'cursor-gray',
      nextStepDelay: 3500,
      nextStepId: 'SENAIT 16',
    },
    {
      id: 'SENAIT 16',
      type: 'sequence',
      sound: SENAIT_FR_SEQ16,
      sound_delay: 50,
      sequence: [
        { type: 'text', text: 'Me voil\u00e0 en Europe. ', delay: 2100 },
        { type: 'text', text: 'Enfin presque\u2026 ', delay: 1040 },
        { type: 'text', text: 'Je suis sur une petite \u00eele Italienne qu\u2019on appelle Lampedusa. ', delay: 1070 },
        { type: 'text', text: 'J\u2019ai appel\u00e9 mon oncle pour lui demander conseil. ', delay: 3880 },
        { type: 'text', text: 'Il m\u2019a dit de le rejoindre en Angleterre, ', delay: 2810 },
        { type: 'text', text: 'o\u00f9 je pourrai travailler avec lui et aussi rembourser ma dette. ', delay: 1110 },
        { type: 'text', text: '', delay: 4040 },
        { type: 'goToNext', delay: 1990 },
      ],
      background: {
        src: refugee,
        style: {},
        animations: [
          { delay: 3000, style: { animationDuration: '12010ms', animationName: 'scale20' } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        ],
      },
      backgroundEffect: {
        style: { opacity: 1, backgroundColor: 'black' },
        animations: [{ delay: 50, style: { animationDuration: '3950ms', animationName: 'opacityFullToNone' } }],
      },
      // textBackgroundColor: '#47423F',
      nextStepId: 'map to belgium',
    },
    //40
    {
      id: 'map to belgium',
      type: 'map',
      background: baseBackgroundImg,
      mapImage: map6,
      mapContainerClass: 'cursor-gray',
      nextStepDelay: 3500,
      nextStepId: 'SENAIT 17',
    },
    {
      id: 'SENAIT 17',
      type: 'sequence',
      sound: SENAIT_FR_SEQ17,
      sound_delay: 50,
      sequence: [
        { type: 'text', text: 'J\u2019ai donc quitt\u00e9 l\u2019Italie et travers\u00e9 la France. ', delay: 2150 },
        { type: 'text', text: 'Me voil\u00e0 en Belgique\n et il me faut maintenant traverser une nouvelle mer.', delay: 2930 },
        { type: 'text', text: 'Il parait qu\u2019on peut le faire en se cachant dans un camion\u2026 ', delay: 3970 },
        { type: 'text', text: '\u00c7a me rassure un peu. ', delay: 2160 },
        { type: 'text', text: 'En attendant, je dors parfois chez des gens ou des associations,', delay: 1950 },
        { type: 'text', text: ' et parfois dans des parcs. ', delay: 3020 },
        { type: 'text', text: 'Il fait froid et j\u2019ai faim. ', delay: 2030 },
        { type: 'text', text: '', delay: 3880 },
        { type: 'goToNext', delay: 4030 },
      ],
      background: {
        src: phoneBooth,
        style: {},
        animations: [
          { delay: 50, style: { animationDuration: '26070ms', animationName: 'scale20' } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        ],
      },
      // textBackgroundColor: '#47423F',
      nextStepId: 'SENAIT 18',
    },
    {
      id: 'SENAIT 18',
      type: 'sequence',
      sound: SENAIT_FR_SEQ18,
      sound_delay: 50,
      sequence: [
        { type: 'text', text: 'J\u2019ai tent\u00e9 de monter dans ces foutus camions, encore et encore. ', delay: 1120 },
        { type: 'text', text: 'Parfois je me dis que je n\u2019ai plus la force de continuer.', delay: 3910 },
        { type: 'text', text: 'Et si j\u2019essayais de demander l\u2019asile ici&thinsp;? ', delay: 3150 },
        { type: 'text', text: ' Au fond je veux juste \u00eatre en s\u00e9curit\u00e9\u2026 ', delay: 3910 },
        { type: 'text', text: 'Mais en Angleterre, avec mon oncle,\n je me retrouverai en famille. ', delay: 3080 },
        { type: 'text', text: '', delay: 4030 },
        { type: 'goToNext', delay: 4850 },
      ],
      background: {
        src: parcMaximilien,
        style: { width: '120vw', position: 'relative', left: '-20vw', transition: 'transform linear' },
        animations: [
          { delay: 50, style: { animationDuration: '24000ms', animationName: 'translateX0To20vw' } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        ],
      },
      // textBackgroundColor: '#47423F',
      nextStepId: 'info in belgium',
    },
    {
      ...base_choice_style,
      id: 'info in belgium',
      type: 'info',

      contentText:
        'Que ferais-tu si tu étais à ma place&thinsp;?<br/>Tenterais-tu encore de traverser <span class="background-underlined large">vers l’Angleterre</span> ou introduirais-tu une <span class="background-underlined very-large">demande en Belgiq</span>ue&thinsp;?',
      actionText: 'Je m’informe pour aider Senait à prendre la bonne décision :',
      actions: [
        {
          type: 'button',
          key: 'button-read',
          text: 'Je découvre cet article sur la traversée vers l’Angleterre',
          buttonStyle: { '&:hover': { color: colors.violet } },
          icon: boutonLire,
          iconHover: boutonLireHoover,
          action: 'openDialog',
          dialogContent: {
            transition: 'slideUp',
            backgroundImage: backgoundPurple,
            type: 'text',
            title: 'Dans les pas des migrant·e·s qui souhaitent rejoindre l’Angleterre',
            text: "Aux abords de la gare du nord de Bruxelles, les passants ne semblent pas remarquer un petit groupe d’Érythréens, fantômes qui se fondent dans le quotidien. Ils sont jeunes, et discrets. L’expérience de l’exil leur a appris la méfiance.<br/><br/>Le train est leur première étape d’un périple pour se rendre sur une aire d’autoroute. La nuit, ils attendront le bon moment pour se glisser dans un camion, en direction de Mons et de Calais. D’autres préfèrent s’adresser à des passeurs. Un riverain, qui a gagné leur confiance, raconte la peur qu’il ressent chez ces jeunes Érythréens, notamment à l’égard des passeurs. <br/><br/>En dépit des innombrables échecs, ceux qu’on appelle des « transmigrants » sont prêts à tout pour atteindre l’Angleterre. Un pays qu’ils ont en ligne de mire car ils y ont souvent de la famille, et qu’on y parle anglais. <br/><br/>Beaucoup séjournent dans le parc Maximilien. Qu’ils soient Érythréens, Éthiopiens ou Soudanais, beaucoup fuient les conflits ou un enrôlement forcé dans un groupe armé. Plus d’un quart d’entre eux sont des mineurs de moins de 18 ans. <br/><br/>Pour certains jeunes dont la situation donnerait droit à l’asile en Belgique, leur objectif de rejoindre l’Angleterre résulte d’une mésinformation: Ils pensent être condamnés à traverser la Manche sous peine d’être renvoyés en Italie ou en Grèce, en application du « Règlement Dublin » qui prévoit qu’un migrant dépose sa demande d’asile dans le premier pays de l’Union Européenne où il pose pied. Or, une fois correctement informés par les associations, beaucoup expriment le souhait de rester en Belgique et d’y d’introduire une demande d’asile. <br/><br/>Cet article fictif est inspiré de l’enquête <a href='https://dossiers.parismatch.be/migrants/migrants.php' target='_blank'>« Migrants&thinsp;: l’autoroute du trafic / Dans les pas des migrants »</a> publiée par Paris Match en 2018.<br/>",
          },
        },
      ],
      nextButtonStyle: {
        '&:hover': { color: colors.violet },
      },
      nextButtonText: 'Prendre une décision >',
      nextStepId: 'choice in belgium',
    },
    {
      id: 'choice in belgium',
      type: 'choice',

      ...base_choice_style,
      contentText:
        'Que ferais-tu si tu étais à ma place&thinsp;?<br/>Tenterais-tu encore de traverser <span class="background-underlined large">vers l’Angleterre</span> ou introduirais-tu une <span class="background-underlined very-large">demande en Belgiq</span>ue&thinsp;?',
      choices: [
        {
          type: 'button',
          key: 'button-1',
          text: "Persévérer pour rejoindre l'Angleterre",
          buttonStyle: choiceButtonStyle,
          action: 'fakeChoice',
          actionText: 'Mes tentatives échouent les unes après les autres. Je suis désespérée&thinsp;! Je finis par abandonner et décide de rester en Belgique.',
          actionTextStyle: { backgroundImage: `url(${blockBlancFakeChoiceSmall})`, maxHeight: '60vh', width: '30vw', maxWidth: '400px' },
        },
        {
          type: 'button',
          key: 'button-2',
          text: 'Introduire une demande en Belgique',
          buttonStyle: choiceButtonStyle,
          action: 'goNext',
          nextStepId: 'SENAIT 19',
        },
      ],
    },
    //45
    {
      id: 'SENAIT 19',
      type: 'sequence',
      sound: SENAIT_FR_SEQ19,
      sound_delay: 50,
      sequence: [
        { type: 'text', text: 'J\u2019ai introduit une demande d\u2019asile.', delay: 6160 },
        { type: 'text', text: 'Apr\u00e8s neuf longs mois, j\u2019ai obtenu un statut de r\u00e9fugi\u00e9e.', delay: 2880 },
        { type: 'text', text: 'Je n\u2019y croyais plus\nque la chance pouvait aussi me sourire.', delay: 3090 },
        { type: 'text', text: 'Je suis enfin en s\u00e9curit\u00e9\u2026 et libre. ', delay: 3900 },
        { type: 'text', text: 'Il y a encore beaucoup d\u2019\u00e9preuves qui m\u2019attendent, \n\u00e0 commencer par trouver un logement. ', delay: 4030 },
        { type: 'text', text: 'Elles sont bien moins grandes que les \u00e9preuves pr\u00e9c\u00e9dentes ', delay: 4940 },
        { type: 'text', text: 'mais pourtant elles me semblent insurmontables. ', delay: 2010 },
        { type: 'text', text: 'Mon assistante sociale me dit que je peux enfin \u201creconstruire ma vie\u201d', delay: 3130 },
        { type: 'text', text: 'mais pour \u00e7a il faut d\u2019abord me \u201creconstruire moi\u201d. ', delay: 3950 },
        { type: 'text', text: 'J\u2019ai l\u2019impression que ce que j\u2019ai v\u00e9cu m\u2019a d\u00e9truit \u00e0 l\u2019int\u00e9rieur, ', delay: 3130 },
        { type: 'text', text: 'm\u00eame si \u00e7a ne se voit pas de l\u2019ext\u00e9rieur.', delay: 2970 },
        { type: 'text', text: 'J\u2019ai des cauchemars de ce qui m\u2019est arriv\u00e9 en Libye.', delay: 2980 },
        { type: 'text', text: 'J\u2019ai besoin de me r\u00e9parer, et \u00e7a demande du temps.', delay: 3050 },
        { type: 'text', text: '', delay: 5000 },
        { type: 'goToNext', delay: 2990 },
      ],
      background: {
        src: porteEtLit,
        style: { transform: 'scale(1.2)' },
        animations: [
          { delay: 50, style: { animationDuration: '54160ms', animationName: 'scaleDown20' } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        ],
      },
      // textBackgroundColor: '#47423F',
      nextStepId: 'SENAIT 20',
    },
    {
      id: 'SENAIT 20',
      type: 'sequence',
      sound: SENAIT_FR_SEQ20,
      sound_delay: 50,
      sequence: [
        { type: 'text', text: 'Mais je n\u2019ai pas le temps. ', delay: 5090 },
        { type: 'text', text: 'Je dois aller \u00e0 l\u2019\u00e9cole la journ\u00e9e, \u00e9tudier le fran\u00e7ais le soir, ', delay: 1140 },
        { type: 'text', text: 'chercher un logement le weekend et aller \u00e0 tous mes rendez-vous. ', delay: 2980 },
        { type: 'text', text: 'Je suis mon propre parent depuis que j\u2019ai 13 ans\n mais je ne suis encore qu\u2019un enfant. ', delay: 3930 },
        { type: 'text', text: 'J\u2019ai besoin qu\u2019on m\u2019aide\u2026', delay: 4870 },
        { type: 'text', text: 'C\u2019est parfois le cas, mais pas toujours. ', delay: 1170 },
        { type: 'text', text: 'Par exemple, aucun propri\u00e9taire ne veut me louer un studio. ', delay: 2920 },
        { type: 'text', text: 'Pareil pour un job d\u2019\u00e9tudiante, \nalors que je dois rembourser mon oncle.', delay: 2950 },
        { type: 'text', text: 'Et j\u2019ai du mal \u00e0 me faire des amis. ', delay: 3060 },
        { type: 'text', text: 'En fait, je veux juste qu\u2019on me donne une chance\nsinon comment avoir un avenir&thinsp;?', delay: 2110 },
        { type: 'text', text: '', delay: 5000 },
        { type: 'goToNext', delay: 1850 },
      ],
      background: {
        src: pousette,
        style: {},
        animations: [
          { delay: 50, style: { animationDuration: '37020ms', animationName: 'scale20' } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        ],
      },
      // textBackgroundColor: '#47423F',
      nextStepId: 'info se battre',
    },
    {
      ...base_choice_style,
      id: 'info se battre',
      type: 'info',

      contentText: 'Je n’en peux plus. <span class="background-underlined very-large">Que dois-je faire&thinsp;?</span>',
      actionText: 'Je m’informe pour aider Senait à prendre la bonne décision :',
      actions: [
        {
          type: 'button',
          key: 'button-watch-1',
          text: 'J’écoute un expert sur le vécu traumatique des réfugiés',
          buttonStyle: { '&:hover': { color: colors.violet } },
          icon: boutonRegarder,
          iconHover: boutonRegarderHoover,
          action: 'openDialog',
          dialogContent: {
            transition: 'slideUp',
            type: 'video',
            videoIframe: getYoutubeIframe('8THRJYItHjQ'),
          },
        },
        
        {
          type: 'button',
          key: 'button-watch-2',
          text: 'J’écoute comment Sham a vécu son arrivée en Belgique',
          buttonStyle: { '&:hover': { color: colors.violet } },
          icon: boutonRegarder,
          iconHover: boutonRegarderHoover,
          action: 'openDialog',
          dialogContent: {
            transition: 'slideUp',
            type: 'video',
            videoIframe: getYoutubeIframe('yE24_FgeLWQ'),
          },
        },
      ],
      nextButtonStyle: {
        '&:hover': { color: colors.violet },
      },
      nextButtonText: 'Prendre une décision >',
      nextStepId: 'choice se battre',
    },
    {
      id: 'choice se battre',
      type: 'choice',

      ...base_choice_style,
      contentText: 'Je n’en peux plus. <span class="background-underlined very-large">Que dois-je faire&thinsp;?</span>',
      choices: [
        {
          type: 'button',
          key: 'button-1',
          text: 'Continuer de me battre',
          buttonStyle: choiceButtonStyle,
          action: 'fakeChoice',
          actionText: 'Non, je n’y arrive plus…',
          actionTextStyle: { backgroundImage: `url(${blockBlancFakeChoiceSmall})`, maxHeight: '60vh', width: '30vw', maxWidth: '400px' },
        },
        {
          type: 'button',
          key: 'button-2',
          text: 'Arrêter de me battre',
          buttonStyle: choiceButtonStyle,
          action: 'goNext',
          nextStepId: 'SENAIT 21',
        },
      ],
    },
    {
      id: 'SENAIT 21',
      type: 'sequence',
      sound: SENAIT_FR_SEQ21,
      sound_delay: 50,
      sequence: [
        { type: 'text', text: 'Je n\u2019ai plus la force de me battre\u2026 ', delay: 8060 },
        { type: 'text', text: 'Je n\u2019ai plus d\u2019\u00e9nergie. ', delay: 2070 },
        { type: 'text', text: 'Mon assistante sociale est venue me voir. ', delay: 2070 },
        { type: 'text', text: 'Elle dit qu\u2019elle ne me laissera pas abandonner. ', delay: 2850 },
        { type: 'text', text: 'Que si moi je n\u2019y crois pas, qu\u2019elle croit en moi assez pour nous deux. ', delay: 2010 },
        { type: 'text', text: 'Parce je suis la personne la plus forte qu\u2019elle connaisse. ', delay: 3100 },
        { type: 'text', text: 'La preuve en est&thinsp;: toutes les \u00e9preuves que j\u2019ai surmont\u00e9 \ndepuis que j\u2019ai 14 ans. ', delay: 2910 },
        { type: 'text', text: 'Que je peux y arriver. ', delay: 3940 },
        { type: 'text', text: 'Ensemble, on d\u00e9cide de contacter des associations.', delay: 2110 },
        { type: 'text', text: '', delay: 3880 },
        { type: 'goToNext', delay: 3190 },
      ],
      background: {
        src: handsBehindWindow,
        style: { transform: 'scale(1.2)' },
        animations: [
          { delay: 50, style: { animationDuration: '36140ms', animationName: 'scaleDown20' } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        ],
      },
      // textBackgroundColor: '#47423F',
      nextStepId: 'SENAIT 22',
    },
    //50
    {
      id: 'SENAIT 22',
      type: 'sequence',
      sound: SENAIT_FR_SEQ22,
      sound_delay: 50,
      sequence: [
        { type: 'text', text: 'Grace \u00e0 une association, j\u2019ai rencontr\u00e9 un ange&thinsp;: \nLucie, et sa famille. ', delay: 4050 },
        { type: 'text', text: '\u00c7a a \u00e9t\u00e9 un tournant pour moi. ', delay: 4040 },
        { type: 'text', text: 'Je sens \u00e0 nouveau que ma vie a de la valeur pour des gens, \net donc pour moi. ', delay: 1920 },
        { type: 'text', text: 'Et avec l\u2019aide de l\u2019association et de Lucie, ', delay: 4020 },
        { type: 'text', text: 'j\u2019ai trouv\u00e9 un studio, un job et j\u2019am\u00e9liore mon fran\u00e7ais.', delay: 2100 },
        { type: 'text', text: 'Les choses commencent \u00e0 se mettre en place, et je vois le bout du tunnel.', delay: 3100 },
        { type: 'text', text: '', delay: 4930 },
        { type: 'goToNext', delay: 3040 },
      ],
      background: {
        src: cuisineLegume,
        style: { transform: 'scale(1.2)' },
        animations: [
          { delay: 50, style: { animationDuration: '27150ms', animationName: 'scaleDown20' } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        ],
      },
      // textBackgroundColor: '#47423F',
      nextStepId: 'SENAIT 23',
    },
    {
      id: 'SENAIT 23',
      type: 'sequence',
      sound: SENAIT_FR_SEQ23,
      sound_delay: 50,
      sequence: [
        { type: 'text', text: 'J\u2019ai le droit de faire un regroupement familial avec ma m\u00e8re \net mes petits fr\u00e8res', delay: 5020 },
        { type: 'text', text: ' pour qu\u2019ils puissent me rejoindre ici. ', delay: 3030 },
        { type: 'text', text: 'Mais il y a un probl\u00e8me&thinsp;: ma famille doit introduire la demande \n\u00e0 l\u2019ambassade belge en \u00c9thiopie, ', delay: 2040 },
        { type: 'text', text: 'puisqu\u2019il n\u2019y a pas d\u2019ambassade en \u00c9rythr\u00e9e. ', delay: 4010 },
        { type: 'text', text: 'Mais s\u2019ils quittent l\u2019\u00c9rythr\u00e9e, ils ne pourront plus revenir \nsi jamais le regroupement familial est refus\u00e9.', delay: 2110 },
        { type: 'text', text: 'Donc ils risquent de rester coinc\u00e9s en \u00c9thiopie pour le reste de leur vie. ', delay: 5880 },
        { type: 'text', text: 'Quel dilemme. ', delay: 4050 },
        { type: 'text', text: 'Je veux faire un regroupement familial pour les emmener en s\u00e9curit\u00e9 ', delay: 1950 },
        { type: 'text', text: 'et non pas pour les mettre davantage en danger. ', delay: 2960 },
        { type: 'text', text: 'Mais ils me manquent et j\u2019ai besoin d\u2019eux,', delay: 3030 },
        { type: 'text', text: 'car je suis encore un enfant, m\u00eame si j\u2019ai des responsabilit\u00e9s d\u2019adulte.', delay: 2140 },
        { type: 'text', text: 'Et si je ne le fais pas maintenant, je ne pourrai plus le faire plus tard \ncar il faut \u00eatre mineur d\u2019\u00e2ge.', delay: 4280 },
        { type: 'text', text: '', delay: 5000 },
        { type: 'goToNext', delay: 3100 },
      ],
      background: {
        src: paperWork,
        style: {},
        animations: [
          { delay: 50, style: { animationDuration: '49050ms', animationName: 'scale10' } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        ],
      },
      backgroundEffect: {
        style: { opacity: 0, backgroundColor: 'black' },
        animations: [{ delay: 44100, style: { animationDuration: '5000ms', animationName: 'opacityNoneToFull' } }],
      },
      textBackgroundColor: '#333333',
      nextStepId: 'info final',
    },
    {
      ...base_choice_style,
      id: 'info final',
      type: 'info',

      contentText:
        'Maintenant tu compren<span class="background-underlined very-large">ds mon dilemme</span>. Que ferais-tu si c’était toi&thinsp;?<br/>Introd<span class="background-underlined large">uirais-tu une deman</span>de de regroupement familial malgré le danger, ou ne pr<span class="background-underlined very-large">endrais-tu pas le risq</span>ue&thinsp;?',
      actionText: 'Je m’informe pour aider Senait à prendre la bonne décision :',
      actions: [
        {
          type: 'button',
          key: 'button-watch-1',
          text: 'Je regarde l’interview de Jonas, directeur de centre pour mineurs étrangers non accompagnés (MENAs)',
          buttonStyle: { '&:hover': { color: colors.violet } },
          icon: boutonRegarder,
          iconHover: boutonRegarderHoover,
          action: 'openDialog',
          dialogContent: {
            transition: 'slideUp',
            type: 'video',
            videoIframe: getYoutubeIframe('y3UJ2cbqDsU'),
          },
        },
        {
          type: 'button',
          key: 'button-ask',
          text: 'Je demande a Senait ce que lui dit son cœur',
          buttonStyle: { '&:hover': { color: colors.violet } },
          icon: boutonCoeur,
          iconHover: boutonCoeurHoover,
          action: 'openDialog',
          dialogContent: {
            type: 'image',
            imageSrc: PhylactereMaman,
            imageStyle: { marginBottom: '15vh', width: '30vw', maxWidth: '400px', height: 'auto', maxHeight: '50vh', objectFit: 'contain', objectPosition: 'center' },
          },
        },
      ],
      nextButtonStyle: {
        '&:hover': { color: colors.violet },
      },
      nextButtonText: 'Prendre une décision >',
      nextStepId: 'choice final',
    },
    {
      id: 'choice final',
      type: 'choice',

      ...base_choice_style,
      contentText:
        'Maintenant tu compren<span class="background-underlined very-large">ds mon dilemme</span>. Que ferais-tu si c’était toi&thinsp;?<br/>Introd<span class="background-underlined large">uirais-tu une deman</span>de de regroupement familial malgré le danger, ou ne pr<span class="background-underlined very-large">endrais-tu pas le risq</span>ue&thinsp;?',
      choices: [
        // {
        //   type: 'button',
        //   key: 'button-ask',
        //   text: 'Je demande a Senait ce que lui dit son cœur',
        //   buttonStyle: { '&:hover': { color: colors.violet } },
        //   icon: boutonCoeur,
        //   iconHover: boutonCoeurHoover,
        //   action: 'openDialog',
        //   dialogContent: {
        //     type: 'image',
        //     imageSrc: PhylactereAlone,
        //     imageStyle: { marginBottom: '15vh', width: '30vw', maxWidth: '400px', height: 'auto', maxHeight: '50vh', objectFit: 'contain', objectPosition: 'center' },
        //   },
        // },
        {
          type: 'button',
          key: 'button-1',
          text: 'Faire une demande de regroupement familial',
          buttonStyle: choiceButtonStyle,
          action: 'showConfirmation',
          confirmationContent: {
            title:
              'Es-<span class="background-underlined medium">tu certain-e</span>&thinsp;?<br/>Je ne me l<span class="background-underlined very-large">e pardonnerai pas s’i</span>l leur arrive quelque-chose.',
            buttons: [
              {
                text: 'Oui, je suis<br/>sûr&middot;e de moi',
                buttonStyle: choiceButtonStyle,
                action: 'goNext',
                nextStepId: 'epilogue final 1',
              },
              {
                text: 'Je reviens<br/>sur ma décision',
                buttonStyle: choiceButtonStyle,
                action: 'closeConfirmation',
              },
            ],
          },
        },
        {
          type: 'button',
          key: 'button-2',
          text: 'Ne pas faire de demande de regroupement familial',
          buttonStyle: choiceButtonStyle,
          action: 'showConfirmation',
          confirmationContent: {
            title: 'Es-t<span class="background-underlined medium">u certain-e</span>&thinsp;?<br/>Je ne peu<span class="background-underlined large">x pas imaginer ne plus</span> les voir',
            buttons: [
              {
                text: 'Oui, je suis<br/>sûr&middot;e de moi',
                buttonStyle: choiceButtonStyle,
                action: 'goNext',
                nextStepId: 'epilogue final 2',
              },
              {
                text: 'Je reviens<br/>sur ma décision',
                buttonStyle: choiceButtonStyle,
                action: 'closeConfirmation',
              },
            ],
          },
        },
      ],
    },
    {
      id: 'epilogue final 1',

      ...base_epilogue,

      sound: SENAIT_FR_EPILOGUE_FINAL1,
      sound_delay: epilogeAnimationTiming+epilogeSoundAdditionalDelay,
      sequence: [
        {
          delay: epilogeAnimationTiming,
          title: 'Voici à quoi ressemble notre vie en Belgique',
          text: "Après une longue procédure, ma mère et mes petits frères sont arrivés&thinsp;! Quel bonheur et quel soulagement... Même si ma mère est heureuse qu'on soit réunis, elle regrette tellement d'avoir échoué à sortir mon père de prison. Nous n'avons toujours pas de nouvelles de lui.<br/>Pour ma part, j'ai enfin eu mon diplôme de secondaire, et je commence mes études d'infirmière, comme j'en rêvais&thinsp;!<br/>La répression continue en Érythrée, ainsi que les drames en Libye et en méditerranée. Je pense à tous ceux qui n'ont pas ma chance, et je me sens terriblement privilégiée.<br/>Ma mère avait raison, malgré tout ce que j'ai traversé, je dois avoir une bonne étoile.",
          textStyle: { left: '45vw' },
        },
      ],
      nextStepId: 'other_choices',
    },
    //55
    {
      id: 'epilogue final 2',

      ...base_epilogue,

      sound: SENAIT_FR_EPILOGUE_FINAL2,
      sound_delay: epilogeAnimationTiming+epilogeSoundAdditionalDelay,
      sequence: [
        {
          delay: epilogeAnimationTiming,
          title: 'Voici à quoi ressemble ma vie en Belgique',
          text: "J'ai enfin eu mon diplôme de secondaire, et je commence mes études d'infirmière.<br/>Mon français est devenu assez bon, et je travaille aussi comme interprète.<br/>Je me suis aussi fait quelques vrais amis.<br/>J'essaie de me réjouir de tout ce qui m'arrive même si j'ai toujours l'impression d'avoir en quelque sorte abandonné ma famille à son sort, ainsi que mon père dont nous n'avons pas de nouvelles.<br/>Des milliers de personnes continuent de subir la répression en Érythrée, ou les violences sur la route.<br/>Je pense à eux, et je mesure la chance que j'ai d'être à présent libre et en sécurité.",
          textStyle: { left: '45vw' },
        },
      ],
      nextStepId: 'other_choices',
    },
    {
      id: 'mapIncoherence1',
      type: 'map',
      background: baseBackgroundImg,
      mapImage: mapIncoherence1,
      mapImageStyle: { maxWidth: '1500px', width: '80vw', height: 'auto' },
      mapContainerClass: 'cursor-gray',
      nextStepDelay: 3500,
      nextStepId: 'SENAIT 12',
    },
    {
      id: 'mapIncoherence2',
      type: 'map',
      background: baseBackgroundImg,
      mapImage: mapIncoherence2,
      mapImageStyle: { maxWidth: '1500px', width: '80vw', height: 'auto' },
      mapContainerClass: 'cursor-gray',
      nextStepDelay: 3500,
      nextStepId: 'epilogue tente',
    },
  ],
};
